import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    ButtonGroup,
    Form,
    DropdownButton,
    Dropdown,
    Tab,
    Tabs,
    Nav
} from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
    // CSVExport,
} from "react-bootstrap-table2-toolkit";
import Modal from "react-bootstrap/Modal";
import Collapse from "react-bootstrap/Collapse";
import Select from 'react-select';
import moment from "moment";
import 'moment/locale/id';
import axios from 'axios';
import { uAPIlocal } from '../../lib/config';
import { withRouter, Redirect } from 'react-router-dom';
import Swal from "sweetalert2";
import { ComboBox } from 'rc-easyui';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import ButtonPrintDefault from './ButtonPrintDefault';
import ButtonPrint from './ButtonPrint';
import ButtonPrintTicket from './ButtonPrintTicket';
import ButtonPrintResep from './ButtonPrintResep';
import ButtonPrintSuratSakit from './ButtonPrintSuratSakit';
import TextPost from './TextPost';
import ReactWhatsapp from 'react-whatsapp';
import volumeUp from "../../../assets/font-awesome/white/png/128/whatsapp.png";
import _rs from "../../../assets/font-awesome/white/png/128/reply-all.png";
import _gt from "../../../assets/font-awesome/white/png/128/refresh.png";

import _editPencil from "../../../assets/font-awesome/white/png/128/pencil-square-o.png";
import _calendar from "../../../assets/font-awesome/black/png/128/calendar.png";
import _calendar_w from "../../../assets/font-awesome/white/png/128/calendar.png";
import _trash from "../../../assets/font-awesome/white/png/128/trash.png";
import _ban from "../../../assets/font-awesome/white/png/128/close.png";
import _credit from "../../../assets/font-awesome/white/png/128/credit-card-alt.png";
import _plus from "../../../assets/font-awesome/white/png/128/plus.png";
import _calendarJ from "../../../assets/font-awesome/black/png/128/calendar-check-o.png";

import CollapseEmail from './CollapseEmail';
import CollapseNoTelp from './CollapseNoTelp';

import { gapi } from 'gapi-script';
import DayPicker, { DateUtils } from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

import Badge from 'react-bootstrap/Badge';
import { TimePicker, Checkbox, Flex, Radio } from 'antd';
import Cookies from 'js-cookie';

let source = axios.CancelToken.source();
axios.defaults.withCredentials = true;

moment.locale('id');
const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
});

const numberFormat = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);



class People extends React.PureComponent {
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
        this.state = {
            redirctTo: false,
            // peserta_filter: "registrasi",
            peserta_filter:
            {
                label: "Registrasi",
                value: "registrasi"
            },
            selectedYear: '2023',
            tableInbox: true,
            datas: [],
            _totalPage: 0,
            showModal: false,
            dataDetail: [],
            selectedRows: null,

            // nextpage
            redirect: false,
            pathname: "",
            idSelected: "",
            prevState: "",
            prevPage: "",
            goTo: "",
            action: "false",


            // props
            _id: this.props.location.state ? this.props.location.state.id : null,
            _conc_id: this.props.location.state ? this.props.location.state.conc_id : null,
            _prevPage: this.props.location.state ? this.props.location.state.prevPage : null,
            _prevState: this.props.location.state ? this.props.location.state.prevState : null,

            searchValue: this.props.location.state ? this.props.location.state.id : null,
            searchWord: '',

            peserta_selected: [],
            filter_peserta: false,
            redirectDetail: [],
            isSearch: false,
            dataSearch: [],

            clr_child: true,
            modalForm: false,
            modalPayment: false,
            modalPemeriksaan: false,

            // form peserta
            peserta_namaPasien: "",
            peserta_NIK: "",
            peserta_NOMR: "",
            peserta_NOREG: "",
            peserta_dateReg: new Date().toISOString().slice(0, 10),
            // peserta_dob: new Date().toISOString().slice(0, 10),
            peserta_jenisKelamin: "Laki - Laki",
            peserta_tempatLahir: "",
            peserta_alamat: "",
            peserta_tglLayanan: new Date().toISOString().slice(0, 10),
            peserta_nasabah: "Pasien Umum",
            peserta_noBuktiLayanan: "",
            peserta_dpjp: "",
            peserta_prioritas: "",
            peserta_tanggalLahir: new Date().toISOString().slice(0, 10),
            peserta_informasi: "",
            peserta_antrian: "",
            peserta_antrianDokter: "",
            peserta_petugas: "",
            peserta_petugasName: "",
            peserta_email: "",
            peserta_noTelp: "",
            // peserta_dateReturn: new Date().toISOString().slice(0, 10),
            peserta_dateReturn: null,
            peserta_jamLayanan: "",

            peserta_idPembayaran: "",
            peserta_metodePembayaran: "CASH",
            peserta_tglPembayaran: new Date().toISOString().slice(0, 10),
            peserta_statusPembayaran: "BELUM LUNAS",
            peserta_ketBiayaKonsul: "",
            peserta_receivedFrom: "",
            peserta_statusSelesai: "",
            peserta_requestStatus: "",
            peserta_requestBranch: "",
            peserta_pembayaranKonsultasiType: "0",
            peserta_pembayaranKonsultasi: "0",
            peserta_pembayaranBio: "0",
            peserta_pembayaranTotal: "0",
            peserta_pembayaranDiskon: "0",
            peserta_alasanDiskon: "",
            peserta_tipePasien: "0",

            tabkey: 1,
            _delSwalPatient: false,
            _editFormActive: false,
            updateBtnV2: false,
            _goPrint: false,

            loading: true,
            ExistingRecord: false,
            historyReg: [],
            historyCount: [],
            editDateReturn: false,

            peserta_janjiHasil: new Date().toISOString().slice(0, 10),
            editJanjiHasil: false,

            minDate: new Date().toISOString().split('T')[0],
            returnDateRequestMode: false,
            selectID_returnDateRequest: "",
            selectStatus_returnDateRequest: "",
            user_selected: [],
            historyBranchSelected: "",

            // optPembayaran: [
            //     {
            //         label: "Cash",
            //         value: "Cash"
            //     },
            //     {
            //         label: "Debit Card",
            //         value: "Debit Card"
            //     },
            //     {
            //         label: "Visa Card",
            //         value: "Visa Card"
            //     },
            //     {
            //         label: "Master Card",
            //         value: "Master Card"
            //     },
            //     {
            //         label: "Transfer Bank",
            //         options: [
            //             {
            //                 label: "BCA",
            //                 value: "BCA"
            //             },
            //             {
            //                 label: "Citibank",
            //                 value: "Citibank"
            //             },
            //             {
            //                 label: "CIMB Niaga",
            //                 value: "CIMB Niaga"
            //             },
            //             {
            //                 label: "Panin",
            //                 value: "Panin"
            //             },
            //             {
            //                 label: "UOB Buana",
            //                 value: "UOB Buana"
            //             },
            //             {
            //                 label: "Standard Chartered",
            //                 value: "Standard Chartered"
            //             },
            //             {
            //                 label: "BNI",
            //                 value: "BNI"
            //             },
            //             {
            //                 label: "MANDIRI",
            //                 value: "MANDIRI"
            //             },
            //             {
            //                 label: "GE Money",
            //                 value: "GE Money"
            //             },
            //             {
            //                 label: "BRI",
            //                 value: "BRI"
            //             },
            //             {
            //                 label: "Mega",
            //                 value: "Mega"
            //             },
            //             {
            //                 label: "RBS",
            //                 value: "RBS"
            //             },
            //         ]
            //     },
            //     {
            //         label: "Pembayaran Instan",
            //         options: [
            //             {
            //                 label: "DANA (SALDO)",
            //                 value: "DANA (SALDO)"
            //             },
            //             {
            //                 label: "DANA (DEBIT)",
            //                 value: "DANA (DEBIT)"
            //             },
            //             {
            //                 label: "DANA (CREDIT CARD)",
            //                 value: "DANA (CREDIT CARD)"
            //             },
            //             {
            //                 label: "OVO",
            //                 value: "OVO"
            //             },
            //             {
            //                 label: "QRIS BCA",
            //                 value: "QRIS BCA"
            //             },

            //         ]
            //     },
            //     {
            //         label: "Pembayaran Lainnya",
            //         options: [
            //             {
            //                 label: "Biaya Home Service I (CARD)",
            //                 value: "Biaya Home Service I (CARD)"
            //             },
            //             {
            //                 label: "Biaya Home Service I (CASH)",
            //                 value: "Biaya Home Service I (CASH)"
            //             },
            //             {
            //                 label: "BIO",
            //                 value: "BIO"
            //             },

            //         ]
            //     },

            // ],


            // optPembayaran: [
            //     {
            //         label: "Cash",
            //         value: "Cash"
            //     },
            //     {
            //         label: "Kartu Debit",
            //         value: "Kartu Debit"
            //     },
            //     {
            //         label: "Kartu Kredit",
            //         value: "Kartu Kredit"
            //     },
            //     {
            //         label: "Transfer Bank",
            //         value: "Transfer Bank"
            //     },
            //     {
            //         label: "Pembayaran Instan",
            //         value: "Pembayaran Instan"
            //     },
            //     {
            //         label: "Pembayaran Lainnya",
            //         value: "Pembayaran Lainnya"
            //     },
            // ],

            optPembayaran: [
                {
                    label: "Cash",
                    value: "Cash"
                },
                {
                    label: "EDC BCA",
                    value: "EDC BCA"
                },
                {
                    label: "EDC CIMB NIAGA",
                    value: "EDC CIMB NIAGA"
                },
                {
                    label: "OVO",
                    value: "OVO"
                },
                {
                    label: "DANA",
                    value: "DANA"
                },
                {
                    label: "Pembulatan",
                    value: "Pembulatan"
                },
            ],

            selectedDay: null,
            allDays: [],
            holiday: [],
            disabledDays: [],
            peserta_tglLayananBeforeReschedule: new Date().toISOString().slice(0, 10),
            opsiJam: [],
            peserta_pekerjaan: "",
            peserta_riwayatKeluhanUtama: "",
            peserta_riwayatPenyakitKeluarga: "",
            peserta_riwayatPenyakitDahulu: "",
            peserta_riwayatAlergiObat: "",


        };
        this.getPatient = this.getPatient.bind(this);
        this.handleRowsClick = this.handleRowsClick.bind(this)
        this.fetchDataDetail = this.fetchDataDetail.bind(this)
        // this.modalRef = this.modalRef.bind(this)
        this.handleModalRedirect = this.handleModalRedirect.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleDayClickReturn = this.handleDayClickReturn.bind(this);
        this.handleDayClickReschedule = this.handleDayClickReschedule.bind(this);

        this.getUserBranch = this.getUserBranch.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.autoLogout = this.autoLogout.bind(this);

        source = axios.CancelToken.source();


    }



    async componentDidMount() {
        this.playInterval();
        console.log("INI STATE PROPS", this.props.location.state);
        if (this.state._id != null) {
            if (this.state._prevPage == "" && this.state._prevState == "") { }
        } else {
            this.getBranch();
            this.getDokter();
            this.getKonsultasi();
            setTimeout(() => {
                this.getPatient();
            }, 6000);

        }

        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        formData.append('id_user', Cookies.get('biomedika-csrf'));
        formData.append('name', localStorage.getItem("name"));
        formData.append('message', "Klinik - Akses Registrasi");


        await axios.post(uAPIlocal + '/api/v1/log', formData, config)
            .then(response => {
                console.log(response)
                if (response.data.status === 406) {
                    console.log(response)

                } else {
                    console.log(response)
                }

            })
            .catch(function (error) {
                console.log(error);
            });

        this.getEvents();


    }

    getEvents() {
        var currentDate = new Date();

        var theFirst = moment(new Date(currentDate.getFullYear(), 0, 1)).format("YYYY-MM-DD");
        var theLast = moment(new Date(currentDate.getFullYear(), 11, 31)).format("YYYY-MM-DD");
        const listDate = [];
        const startDate = theFirst;
        const endDate = theLast;
        const dateMove = new Date(startDate);
        let strDate = startDate;

        while (strDate < endDate) {
            strDate = dateMove.toISOString().slice(0, 10);
            listDate.push(strDate);
            dateMove.setDate(dateMove.getDate() + 1);
        };

        console.log("listDate", listDate);
        this.setState({
            allDays: listDate,
        })

        const disabledDays = this.state.disabledDays.concat();
        listDate.map(item => (
            disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
        ))
        this.setState({ disabledDays: disabledDays }, () => console.log("ini adalah selectedday", this.state.disabledDays));

        // gapi.load('client', () => {
        //     gapi.client.init({
        //         apiKey: 'AIzaSyC8IUhutHMsapW-yYWSgrGmN8Pf3W_wcbA',
        //         clientId: '98416715227-u6mu3sgmph5n6mqk009r4tfo3gii01uq.apps.googleusercontent.com',
        //         scope: 'https://www.googleapis.com/auth/calendar',
        //         discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        //     }).then(() => {
        //         var request = gapi.client.request({
        //             'path': "https://www.googleapis.com/calendar/v3/calendars/en.indonesian%23holiday%40group.v.calendar.google.com/events?key=AIzaSyC8IUhutHMsapW-yYWSgrGmN8Pf3W_wcbA",
        //         });

        //         request.execute(function (event) {
        //             // console.log("ini libur", event);
        //             let _holiday = [];
        //             let _summary = ["New Year's Day", "Ascension of the Prophet Muhammad", "Lunar New Year's Day", "Bali's Day of Silence and Hindu New Year (Nyepi)", "Good Friday", "Easter Sunday", "Idul Fitri", "Idul Fitri Holiday", "International Labor Day", "Ascension Day of Jesus Christ", "Waisak Day (Buddha's Anniversary)", "Pancasila Day", "Idul Adha", "Muharram / Islamic New Year", "Indonesian Independence Day", "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)", "Christmas Day"];
        //             event.items.map((item, index) => {
        //                 // console.log("ini libur", item.summary);
        //                 // console.log("ini libur", item.start.date);
        //                 if (moment(item.start.date, "YYYY-MM-DD").format("YYYY") == moment().year()) {
        //                     // _holiday.push({ date: item.start.date, detail: item.summary });
        //                     if (_summary.includes(item.summary)) {
        //                         if (item.summary == "Maulid Nabi Muhammad (The Prophet Muhammad's Birthday)") {
        //                             let addOne = moment(item.start.date).add(1, 'days');
        //                             // alert(addOne);
        //                             _holiday.push(moment(addOne).format("YYYY-MM-DD"));
        //                         } else {
        //                             _holiday.push(item.start.date);
        //                         }
        //                     }
        //                 }

        //                 console.log("ini libur", _holiday);
        //             })
        //         });
        //     })
        // })


    }

    componentDidUpdate(prevProps, prevState) {
        console.log(prevState, "prev state")
        if (prevState.selectedRows !== this.state.selectedRows) {
            // console.log(this.state.selectedRows, "selectedRows")
            // console.log(prevState, "prev")
            var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
            if (element) {
                element.classList.add('row-custom-selected')
                var element2 = document.getElementById(`border-custom-${prevState.selectedRows}`)
                if (element2) {
                    element2.classList.remove('row-custom-selected')
                    // console.log(this.state.showModal, "showModal")
                }
            }
            console.log(element, 'element')
        }
    }
    componentWillUnmount() {
        window.location.reload();
        this.stopInterval();
        document.removeEventListener("mousedown", this.handleClose)
        if (source) {
            source.cancel("Landing Component got unmounted");
        }
    }

    logPrint(x, y) {

        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'

            }

        };

        formData.append('id_user', Cookies.get('biomedika-csrf'));
        formData.append('name', localStorage.getItem("name"));
        formData.append('message', "Klinik - Print Kuitansi Pasien - " + x + " (" + y + ")");


        axios.post(uAPIlocal + '/api/v1/log', formData, config)
            .then(response => {
                console.log(response)
                if (response.data.status === 406) {
                    console.log(response)

                } else {
                    console.log(response)
                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }

    playInterval() {
        if (this.state.showModal) {
            this.stopInterval();
        }

        this.interval = setInterval(() => {
            console.log("interval load")
            this.getPatient();
        }, 30000);
    }

    stopInterval() {
        clearInterval(this.interval);
    }

    openModalAddForm() {
        this.setState({ modalForm: true, modalPayment: false, ExistingRecord: false, tabkey: 1 })
        this.stopInterval();
    }


    fetchDataDetail(ID_REGISTRASI, DATA, TYPE) {

        let _url = "";
        if (this.state.peserta_filter?.value == "registrasi") {
            _url = `/api/v1/detail-patientreg/${ID_REGISTRASI}`
        } else {
            _url = `/api/v1/detail-patient/${ID_REGISTRASI}`
        }

        axios.post(uAPIlocal + _url, {
            cancelToken: source.token
        })
            .then(function (response) {
                return response.data;
            })
            .then(response => {
                console.log(response.results, "ini hasil dari detail 2")

                if (response.results.length == 0) {
                    this.setState({
                        dataDetail: DATA,
                        choosePembayaran: this.state.optPembayaran[0],
                        peserta_tglPembayaran: new Date().toISOString().slice(0, 10),
                        dateStatusPembayaranHour: moment(new Date().toISOString().slice(0, 10), 'hh:mm:ss').format("hh:mm:ss"),
                        peserta_statusPembayaran: "BELUM LUNAS",
                        // chooseKonsultasi: this.state.optKonsultasi[0],
                        peserta_ketBiayaKonsul: "",
                        peserta_receivedFrom: "",
                        updateBtnV3: false,
                    })

                } else {
                    let _DATA = response.results[0];
                    if (TYPE == "email") {
                        this.sendEmail(_DATA);
                    } else {
                        console.log("detail with pembayaran", _DATA)
                        let indexKonsultasi = this.state.optKonsultasi.findIndex(function (item, i) {
                            return item.value === DATA.ID_KONSULTASI
                        });
                        let indexPembayaran = this.state.optPembayaran.findIndex(function (item, i) {
                            return item.value === _DATA.METODE_PEMBAYARAN
                        });

                        this.setState({
                            dataDetail: _DATA,
                            peserta_idPembayaran: _DATA.ID_PEMBAYARAN,
                            choosePembayaran: this.state.optPembayaran[indexPembayaran],
                            peserta_tglPembayaran: moment(_DATA.DATE_PEMBAYARAN, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            dateStatusPembayaranHour: moment(_DATA.DATE_PEMBAYARAN, 'hh:mm:ss').format("hh:mm:ss"),
                            peserta_statusPembayaran: _DATA.STATUS,
                            // chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                            peserta_ketBiayaKonsul: _DATA.KETERANGAN_BIAYA_KONSULTASI,
                            peserta_receivedFrom: _DATA.RECEIVED_FROM,
                            peserta_statusSelesai: DATA.STATUS,
                            updateBtnV3: true,
                        })

                    }



                }

                this.setState({ showModal: true, clr_child: false })

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    detailRow = (ID_REGISTRASI) => {

        // detailRow(ID_REGISTRASI) {
        let _url = `/api/v1/detail-patient/${ID_REGISTRASI}`;
        axios.post(uAPIlocal + _url, {
            cancelToken: source.token
        })
            .then(function (response) {
                return response.data;
            })
            .then(response => {
                console.log(response.results, "ini hasil dari detail 1")
                return response.results;

            })
            .catch(function (error) {
                console.log(error);
            });
    }


    handleModalRedirect(id) {
        var id_company = localStorage.getItem("Company_ID");
        if (this.state._prevPage == "department" && this.state._prevState == "department_peserta") {
            this.setState({
                redirect: true,
                pathname: "/admin/departemen",
                idSelected: this.state._id,
                prevState: "back",
                prevPage: "people",
                goTo: this.state._prevState,
            });
        }

        if (id) {
            // this.fetchDataDetail(id, id_company)
        }
    }

    handleClose = event => {
        if (this.modalRef && !this.modalRef.textContent) {
            this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
            if (element) {
                element.classList.remove(`row-custom-selected`)
            }
        }

    }



    async getPatient() {
        if (this.state.historyBranchSelected != "") {
            if (this.state.chooseBranchPatient?.value != this.state.historyBranchSelected) {
                this.setState({ datas: [], historyBranchSelected: this.state.chooseBranchPatient?.value })
            } else {
                // this.setState({ datas: [] })
            }
        }


        // var id_company = localStorage.getItem("Company_ID");
        var year = this.state.selectedYear;
        console.log(this.state.searchValue, "search value")
        // alert(this.state.peserta_filter?.value)

        var _b = this.state.chooseBranchPatient?.value;

        if (_b == undefined || _b == "") {
            _b = "ALL";
        } else {
            _b = this.state.chooseBranchPatient?.value;
        }

        // alert(this.state.chooseBranchPatient?.value)
        // alert(this.state.historyBranchSelected)
        console.log("ini branch pilihan", _b)
        await axios.post(uAPIlocal + `/api/v1/patient/${this.state.peserta_filter?.value}?branch=${_b}`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(async response => {
                // console.log("mydata pasien results", response.results);

                let datas = response.results;
                if (response.results.length == 0) {
                    this.setState({ tableInbox: true });
                }
                const mydata = datas.sort(function (a, b) {
                    return b.ID_REGISTRASI - a.ID_REGISTRASI;
                });


                if (mydata.length > 0) {

                    const setData = (event) => {
                        // this.setState({ datas: [] });
                        const _datas = mydata.sort(function (a, b) {
                            return b.ID_REGISTRASI - a.ID_REGISTRASI;
                        });
                        // this.setState({ datas: _datas })
                        this.setState({ datas: _datas }, () => setTimeout(() => { this.setState({ tableInbox: true }) }, 1000));
                    };

                    console.log("ini mydata refresh", mydata);

                    await mydata.map(async function (item, index) {
                        let getDetail = await axios.post(uAPIlocal + `/api/v1/detail-patient/${item.ID_REGISTRASI}`, {
                            cancelToken: source.token
                        })
                        //  console.log("ini getDetail",getDetail.data.results[0]);
                        if (getDetail.data.results[0]) {
                            console.log("kondisi 1");
                            let keyIndex = mydata.findIndex((x) => x.ID_REGISTRASI === getDetail.data.results[0].ID_REGISTRASI);
                            console.log("ini getDetail", getDetail.data.results[0].ID_REGISTRASI + "==" + keyIndex);
                            if (keyIndex != -1) {
                                var newKey = "STATUS_PEMBAYARAN";
                                var newVal = getDetail.data.results[0].STATUS;
                                mydata[keyIndex][newKey] = newVal;
                                mydata[keyIndex]["ID_PEMBAYARAN"] = getDetail.data.results[0].ID_PEMBAYARAN;
                                mydata[keyIndex]["ID_KONSULTASI"] = getDetail.data.results[0].ID_KONSULTASI;
                                mydata[keyIndex]["DATE_PEMBAYARAN"] = getDetail.data.results[0].DATE_PEMBAYARAN;
                                mydata[keyIndex]["METODE_PEMBAYARAN"] = getDetail.data.results[0].METODE_PEMBAYARAN;
                                mydata[keyIndex]["TOTAL_HARGA"] = getDetail.data.results[0].TOTAL_HARGA;
                                mydata[keyIndex]["RECEIVED_FROM"] = getDetail.data.results[0].RECEIVED_FROM;
                                mydata[keyIndex]["statusSelesai"] = getDetail.data.results[0].statusSelesai;
                                mydata[keyIndex]["KETERANGAN_BIAYA_KONSULTASI"] = getDetail.data.results[0].KETERANGAN_BIAYA_KONSULTASI;
                                mydata[keyIndex]["SURAT_SAKIT_HARI"] = getDetail.data.results[0].SURAT_SAKIT_HARI;
                            } else { }
                        } else {
                            console.log("kondisi 2");
                            let keyIndex = mydata.findIndex((x) => x.ID_REGISTRASI === item.ID_REGISTRASI);
                            console.log("ini getDetail", keyIndex);
                            var newKey = "STATUS_PEMBAYARAN";
                            var newVal = "Belum Dibayar";
                            mydata[keyIndex][newKey] = newVal;
                        }

                        if (mydata.length == (index + 1)) {

                            setTimeout(() => {
                                setData();
                            }, 1000);

                        }


                    });

                } else {
                    this.setState({ datas: [] })
                }





                // const matchedPatient = _datas.filter(i => this.state.peserta_selected.indexOf(i.Patient_id) >= 0)
                // if (this.state.filter_peserta == true) {
                //     this.setState({ datas: matchedPatient })
                // } else {
                //     this.setState({ datas: _datas })
                // }


                // unique NOMR
                // const _datasUniqueNOMR = response.results.sort(function (a, b) {
                //     return a.NOMR < b.ID_NOMR;
                // });

                // const uniqueNOMR = _datasUniqueNOMR.filter((value, index, self) => self.map(x => x.NOMR).indexOf(value.NOMR) == index)
                // console.log('uniqueNOMR', uniqueNOMR)

                // let _NOMR = []
                // if (uniqueNOMR.length > 0) {
                //     uniqueNOMR.forEach(element => {
                //         if (element.NOMR) {
                //             _NOMR.push({
                //                 value: element.NOMR,
                //                 label: element.NOMR + " - " + element.NAMA_PASIEN,
                //             })
                //         }
                //     });
                // }

                // if (this.state.ExistingRecord) {
                //     this.setState({ optNOMR: _NOMR, chooseNOMR: _NOMR[0] }, () =>
                //         this.cekNOMRExam(_NOMR[0].value)
                //     )
                // } else {
                //     this.setState({ optNOMR: _NOMR, chooseNOMR: _NOMR[0] })
                //     this.setState({ optNOMR: _NOMR, chooseNOMR: "" })
                // }

                // this.setState({ optNOMR: _NOMR, chooseNOMR: _NOMR[0] }, () =>
                //     this.cekNOMRExam(_NOMR[0].value)
                // )


                if (Number.isInteger(response.results.length / 10) == true) {
                    var x = (response.results.length / 10);
                    this.setState({
                        _totalPage: x
                    })
                } else {
                    var x = Math.round(this.state.datas.length / 10) < (this.state.datas.length / 10) ? Math.round(this.state.datas.length / 10) + 1 : Math.round(this.state.datas.length / 10);
                    this.setState({
                        _totalPage: x
                    })

                }

                this.getAllPatientForNOMR();


            })
            .catch((e) => {
                console.log(e);
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
                this.autoLogout();
            });
    }

    autoLogout = () => {
        this.setState({ redirctTo: true });
    }

    async getAllPatientForNOMR() {

        console.log(this.state.searchValue, "search value")
        await axios.post(uAPIlocal + `/api/v1/patient/nomr`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {

                // unique NOMR
                const _datas = response.results.sort(function (a, b) {
                    return b.NOMR - a.ID_NOMR;
                });

                console.log("ini datas for MR", _datas)
                this.setState({ alldatas: _datas })


                const uniqueNOMR = _datas.filter((value, index, self) => self.map(x => x.NOMR).indexOf(value.NOMR) == index)
                console.log('uniqueNOMR', uniqueNOMR)

                let _NOMR = [];
                _NOMR.push({
                    value: "",
                    label: "--- Pilih Peserta ---",
                });
                if (uniqueNOMR.length > 0) {
                    uniqueNOMR.forEach(element => {

                        if (element.NOMR) {
                            _NOMR.push({
                                value: element.NOMR,
                                label: element.NOMR + " - " + element.NAMA_PASIEN,
                            })
                        }
                    });
                }


                this.setState({ optNOMR: _NOMR, chooseNOMR: "" })


                // get LastNumber NOREG
                console.log('last user day', _datas[0].TGL_LAYANAN)
                console.log('last user no mr', _datas[0].NOREG)
                let lastNumber_NOREG = _datas[0].NOREG;
                let ln_NOREG = lastNumber_NOREG.slice(6);
                let lnf_NOREG = ln_NOREG.match(/\d/g).join("");
                console.log("last no mr", lnf_NOREG);
                this.setState({ lastNOREG: lnf_NOREG });


                // console.log('last user NOMR klinik', _datas[0].NOMR);
                // let lastNumber_NOMR = _datas[0].NOMR;
                // let ln_NOMR = lastNumber_NOMR.slice(5);
                // console.log("last pdi klinik", ln_NOMR);
                // this.setState({ lastNOMR: ln_NOMR });

                console.log('last user NO. BUKTI LAYANAN', _datas[0].NO_BUKTI_LAYANAN);
                let lastNumber_NO_BUKTI_LAYANAN = _datas[0].NO_BUKTI_LAYANAN;
                let ln_NO_BUKTI_LAYANAN = lastNumber_NO_BUKTI_LAYANAN.substring(0, lastNumber_NO_BUKTI_LAYANAN.indexOf('-'));
                console.log("last NO. BUKTI LAYANAN", ln_NO_BUKTI_LAYANAN);
                this.setState({ lastNO_BUKTI_LAYANAN: ln_NO_BUKTI_LAYANAN });
                this.setState({ lastTGL_LAYANAN: _datas[0].TGL_LAYANAN });



                console.log("ini tidak null", _datas.filter(x => x.ANTRIAN_DOKTER != ""))

                let _datasNotNull = _datas.filter(x => x.ANTRIAN_DOKTER != "");
                console.log('last user NO. BUKTI ANTRIAN DOKTER', _datasNotNull[0].ANTRIAN_DOKTER);
                let lastNumber_NO_ANTRIAN_DOKTER = _datasNotNull[0].ANTRIAN_DOKTER;
                let ln_NO_BUKTI_ANTRIAN_DOKTER = lastNumber_NO_ANTRIAN_DOKTER.match(/\d+/g);
                let ln_KODE_ANTRIAN_DOKTER = lastNumber_NO_ANTRIAN_DOKTER.match(/[a-zA-Z]+/g);
                this.setState({ lastNO_BUKTI_ANTRIAN_DOKTER: ln_NO_BUKTI_ANTRIAN_DOKTER });
                this.setState({ lastKODE_ANTRIAN_DOKTER: ln_KODE_ANTRIAN_DOKTER });
                this.setState({ lastBRANCH_ANTRIAN_DOKTER: _datasNotNull[0].NO_BUKTI_LAYANAN.slice(-1) });


            })
            .catch(function (error) {
                console.log(error);
            });
    }


    async getDokter() {

        await axios.post(uAPIlocal + `/api/v1/dokter`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata dokter", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.NAMA_DOKTER < b.NAMA_DOKTER;
                });

                let _dokter = []
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        // if (element.level == 2) {
                        _dokter.push({
                            value: element.ID_DOKTER,
                            label: element.NAMA_DOKTER,
                        })
                        // }
                    });
                }
                this.setState({ optDokter: _dokter, chooseDokter: _dokter[0] }, () =>
                    console.log("ok")
                )


            })
            .catch(function (error) {
                console.log(error);
            });
    }


    async getKonsultasi() {
        // var id_company = localStorage.getItem("Company_ID");
        var year = this.state.selectedYear;
        console.log(this.state.searchValue, "search value")
        await axios.post(uAPIlocal + `/api/v1/konsultasi`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata konsul", response.results);

                const _datas = response.results.sort(function (a, b) {
                    return a.NAMA_KONSULTASI < b.NAMA_KONSULTASI ? -1 : 1;
                });


                let konsultasi = []
                if (_datas.length > 0) {

                    konsultasi.push({
                        value: 0,
                        label: '--- Pilih Poli / Konsultasi ---',
                        price: 0,
                        kode: '-',
                        branch: ""
                    })

                    _datas.forEach(element => {
                        if (element.ID_KONSULTASI) {
                            konsultasi.push({
                                value: element.ID_KONSULTASI,
                                label: element.NAMA_KONSULTASI + " - " + element.branch_name,
                                price: element.HARGA_KONSULTASI,
                                kode: element.KODE_KONSULTASI,
                                branch: element.branch_code,
                                nama: element.NAMA_KONSULTASI,
                            })
                        }
                    });
                }
                this.setState({ optKonsultasi: konsultasi, chooseKonsultasi: konsultasi[0] }, () =>
                    console.log("ok")
                )

                // let indexDokter = this.state.optDokter.findIndex(function (item, i) {
                //     return item.value === konsultasi[0].dokter
                // });

                // this.setState({ chooseDokter: this.state.optDokter[indexDokter] })

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getDokterKonsultasi(id) {

        let f = new FormData();
        f.append('ID_KONSULTASI', id);
        await axios({
            method: "post",
            url: uAPIlocal + "/api/v1/dokterkonsultasi",
            data: f,
            headers: { 'content-type': 'multipart/form-data' }
        })
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata dokter konsultasi", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.NAMA_DOKTER < b.NAMA_DOKTER ? -1 : 1;
                });


                let _dokter = []
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        // if (element.level == 2) {
                        _dokter.push({
                            value: element.ID_DOKTER,
                            label: element.NAMA_DOKTER,
                            id: element.ID_PENUGASAN
                        })
                        // }
                    });
                }

                if (_dokter.length > 0) {
                    this.setState({ optDokterKonsultasi: _dokter, chooseDokterKonsultasi: _dokter[0] }, () =>
                        this.getJamJadwal(_dokter[0].id)
                    )
                } else {
                    this.setState({ optDokterKonsultasi: [], chooseDokterKonsultasi: [] }, () =>
                        alert("Tidak ada dokter!")
                    )

                    const disabledDays = this.state.disabledDays.concat();
                    this.state.allDays.map(item => (
                        disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
                    ))

                    this.setState({ disabledDays: disabledDays });

                }



            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getJamJadwal(val) {
        this.getJadwal(val);
    }


    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata branch", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.branch_name > b.branch_name;
                });


                let branch = [];
                branch.push({
                    value: "",
                    label: "-- Semua Cabang --",
                })
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        if (element.branch_code) {
                            branch.push({
                                value: element.branch_code,
                                label: element.branch_name,
                            })
                        }
                    });
                }

                this.setState({ optBranch: branch }, () =>
                    console.log("ok")
                )

                let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                    return item.value === localStorage.getItem("branch")
                });

                this.setState({ chooseBranch: this.state.optBranch[indexBranch], chooseBranchPatient: this.state.optBranch[indexBranch] })

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    getUserBranch(l, b) {
        axios.post(uAPIlocal + `/api/v1/user/${"getuserbranch"}?branch=${b}&lvl=${l}`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata admin branch", response.results);
                let datas = response.results;
                this.setState({ user_selected: datas })
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    imgFormatter(cell, row) {
        return (
            <div className="rounded-corners-users"></div>
        );
    }

    handleRowsClick(cell, row, rowIndex) {
        console.log(this.state.selectedRows, "handle function")
        return (
            <div className={`border-custom-${rowIndex}`} id={`border-custom-${rowIndex}`}>
                {cell}
            </div>
        )
    }
    // emptyValueFormatter(cell, row, rowIndex) {
    //     if (cell === null || cell === undefined || cell === "") {
    //         return "";
    //     }
    //     return cell;
    // };
    // btnFormatter = (cell, row) => {
    //     const onclick = (event) => {
    //         // console.log("clicked on row ", row);
    //         this.handleShowModalSentTo();
    //     };
    //     return (
    //         <Button
    //             className="button-block btn-tropical-rain-forest"
    //             onClick={onclick}
    //             style={{ zIndex: 99 }}
    //         >
    //             1/1
    //         </Button>
    //     );
    // };
    // redValueFormatter(cell, row, rowIndex) {
    //     console.log(cell, "ini cell")
    //     console.log(row.F2023, "ini row")
    //     console.log(rowIndex, "ini rowindex")

    //     if (row.F2023 === "High") {
    //         return (<p style={{ color: 'red' }}>{cell}</p>);
    //     }
    //     if (row.F2023 === "Low") {
    //         return (<p style={{ color: 'red' }}>{cell}</p>);
    //     }
    //     return cell;
    // };


    handleLastPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(this.state._totalPage);
    }


    handleNextPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(page + 1);
    }

    handlePrevPage = ({
        page,
        onPageChange
    }) => () => {
        onPageChange(page - 1);
    }

    // handleSizePerPage = ({
    //     page,
    //     onSizePerPageChange
    // }, newSizePerPage) => {
    //     onSizePerPageChange(newSizePerPage, page);
    // }



    handleCloseModalDetail = () => () => {
        this.playInterval();

        this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })

        // var element = document.getElementById(`border-custom-${this.state.selectedRows}`)
        // if (element) {
        // element.classList.remove(`row-custom-selected`)
        // }

        if (this.state._prevPage == "top10" && this.state._prevState == "top10_peserta") {
            this.setState({ action: true })
        }

        if (this.state._prevPage == "department" && this.state._prevState == "department_peserta") {
            this.setState({ action: true })
        }
    }




    handleCloseModalForm() {
        this.setState({ modalForm: false });
        this.resetForm();
    }

    handleCloseModalPayment() {
        this.setState({ modalPayment: false });
        this.resetForm();
    }

    handleCloseModalPemeriksaan() {
        this.setState({ modalPemeriksaan: false });
        this.resetForm();
    }


    resetForm(justReset) {

        if (justReset) {
            this.stopInterval();
        } else {
            this.playInterval();
        }

        this.setState({
            peserta_namaPasien: "",
            peserta_NIK: "",
            peserta_NOMR: "",
            peserta_NOREG: "",
            peserta_dateReg: new Date().toISOString().slice(0, 10),
            peserta_jenisKelamin: "Laki-Laki",
            peserta_tempatLahir: "",
            peserta_alamat: "",
            peserta_tglLayanan: new Date().toISOString().slice(0, 10),
            peserta_nasabah: "Pasien Umum",
            peserta_noBuktiLayanan: "",
            peserta_dpjp: "",
            peserta_prioritas: "",
            peserta_tanggalLahir: new Date().toISOString().slice(0, 10),
            peserta_informasi: "",
            peserta_antrian: "",
            peserta_antrianDokter: "",
            peserta_petugas: "",
            peserta_petugasName: "",
            peserta_email: "",
            peserta_noTelp: "",
            // peserta_dateReturn: new Date().toISOString().slice(0, 10),
            peserta_dateReturn: null,
            peserta_jamLayanan: "",
            peserta_idPembayaran: "",
            peserta_metodePembayaran: "CASH",
            peserta_tglPembayaran: new Date().toISOString().slice(0, 10),
            peserta_statusPembayaran: "BELUM LUNAS",
            peserta_ketBiayaKonsul: "",
            peserta_receivedFrom: "",
            peserta_statusSelesai: "",
            peserta_requestStatus: "",
            peserta_requestBranch: "",
            peserta_pekerjaan: "",
            peserta_riwayatKeluhanUtama: "",
            peserta_riwayatPenyakitKeluarga: "",
            peserta_riwayatPenyakitDahulu: "",
            peserta_riwayatAlergiObat: "",
            tabkey: 1,
            updateBtnV2: false,
            updateBtnV3: false,
            ExistingRecord: false,
            showModal: false,
            _goPrint: false,
            _delSwalPatient: false,
            _editFormActive: false,
            clr_child: true,
            dataDetail: [],
            loading: true,
            historyReg: [],
            historyCount: [],
            chooseKonsultasi: this.state.optKonsultasi[0],
            optDokterKonsultasi: [],
            chooseDokterKonsultasi: [],
            chooseNOMR: this.state.optNOMR[0],
            editDateReturn: false,
            editRequestStatus: false,
            returnDateRequestMode: false,
            selectID_returnDateRequest: "",
            selectStatus_returnDateRequest: "",
            user_selected: [],
            historyBranchSelected: "",
            disabledDays: [],
            peserta_tglLayananBeforeReschedule: new Date().toISOString().slice(0, 10),
            opsiJam: [],
            peserta_pembayaranKonsultasiType: "0",
            peserta_pembayaranKonsultasi: "0",
            peserta_pembayaranBio: "0",
            peserta_pembayaranTotal: "0",
            peserta_pembayaranDiskon: "0",
            peserta_alasanDiskon: "",
            peserta_tipePasien: "0",

            peserta_janjiHasil: new Date().toISOString().slice(0, 10),
            editJanjiHasil: false,

        })

        const disabledDays = this.state.disabledDays.concat();
        this.state.allDays.map(item => (
            disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
        ))

        this.setState({ disabledDays: disabledDays });

        let indexBranch = this.state.optBranch.findIndex(function (item, i) {
            return item.value === localStorage.getItem("branch")
        });

        this.setState({ chooseBranch: this.state.optBranch[indexBranch] })

    }

    onChange(e) {
        console.log(e.target.value);
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    generateNumber(lastNumber) {
        var _generatedValue = parseInt(lastNumber, 10);
        _generatedValue = _generatedValue || 0;
        _generatedValue++;
        var _generatedValueLength = 0;
        if (_generatedValue.toString().length < 4) {
            _generatedValueLength = lastNumber.length;
        } else {
            _generatedValueLength = _generatedValue.toString().length;
        }
        var _nol = "";
        for (var i = 0; i < _generatedValueLength; i++) {
            _nol = _nol + "0";
        }
        var newValue = (_nol + _generatedValue).slice(-_nol.length);
        return newValue;
    }

    async cekNOMRExam(NOMR) {
        // alert(NOMR)
        this.setState({ historyReg: [], historyCount: [] })
        let f = new FormData();

        if (NOMR == "") {
            this.resetForm("handleNoMR");
        } else {
            if (NOMR) {
                f.append('NOMR', NOMR);
            } else {
                f.append('NOMR', this.state.chooseNOMR?.value);
            }
            axios({
                method: "post",
                url: uAPIlocal + "/api/v1/cek_nomr",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini NOMR 1", response.data.results);
                    var row = response.data.results[0];

                    this.setState({
                        // peserta_idReg: row.ID_REGISTRASI,
                        peserta_namaPasien: row.NAMA_PASIEN,
                        peserta_NIK: row.NIK,
                        // peserta_NOMR: row.NOMR,
                        // peserta_NOREG: row.NOREG,
                        // peserta_dateReg: moment(row.DATE_REGISTRASI, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                        peserta_jenisKelamin: row.JENIS_KELAMIN,
                        peserta_tempatLahir: row.TEMPAT_LAHIR,
                        peserta_alamat: row.alamatPasien,
                        // peserta_tglLayanan: moment(row.TGL_LAYANAN, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                        peserta_nasabah: row.NASABAH,
                        // peserta_noBuktiLayanan: row.NO_BUKTI_LAYANAN,
                        // peserta_dpjp: row.DPJP,
                        // peserta_prioritas: row.PRIORITAS,
                        peserta_tanggalLahir: row.TANGGAL_LAHIR,
                        // peserta_informasi: row.INFORMASI,
                        // peserta_antrian: row.ANTRIAN,
                        // peserta_petugas: row.PETUGAS_INPUT,
                        peserta_noTelp: row.NO_TELP,
                        peserta_email: row.EMAIL,
                        peserta_pekerjaan: row.PEKERJAAN,
                        peserta_riwayatKeluhanUtama: row.RIWAYAT_KELUHAN_UTAMA,
                        peserta_riwayatPenyakitKeluarga: row.RIWAYAT_PENYAKIT_KELUARGA,
                        peserta_riwayatPenyakitDahulu: row.RIWAYAT_PENYAKIT_DAHULU,
                        peserta_riwayatAlergiObat: row.RIWAYAT_ALERGI_OBAT,
                        // peserta_petugasName: row.name,
                        // dateRegHour: moment(row.DATE_REGISTRASI, 'hh:mm:ss').format("hh:mm:ss"),
                        // peserta_metodePembayaran: row.METODE_PEMBAYARAN,
                        // peserta_tglPembayaran: moment(row.DATE_PEMBAYARAN, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                        // dateStatusPembayaranHour: moment(row.DATE_PEMBAYARAN, 'hh:mm:ss').format("hh:mm:ss"),
                        // peserta_statusPembayaran: row.STATUS,
                        // chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                        // chooseBranch: this.state.optBranch[indexBranch],
                        // chooseDokter: this.state.optDokter[indexDokter],
                        // peserta_idPembayaran: row.ID_PEMBAYARAN,
                        // tabkey: 1,
                        // _editFormActive: true,
                        // updateBtnV2: true,
                        ExistingRecord: true,
                    })

                    this.setState({ historyReg: [...this.state.historyReg, response.data.results] })
                    this.cekNOMRExam2();
                })
                .catch((e) => {
                    console.error(e);
                });
        }

    }

    async cekNOMRExam2() {
        this.state.historyReg.map((item, index) => {
            let f = new FormData();
            f.append('NOREG', item[index].NOREG);
            axios({
                method: "post",
                url: uAPIlocal + "/api/v1/detail_patient",
                data: f,
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then((res) => {

                    if (res.data.results.length > 0) {
                        this.setState({ historyCount: [...this.state.historyCount, 1] })
                    }

                    if (this.state.historyReg.length == (index + 1)) {
                        console.log("ini historyCount", this.state.historyCount.length);
                    }

                })
                .catch((err) => {
                    console.log('err', err)
                })

        })
    }



    save_v2() {
        // alert(this.state.chooseKonsultasi?.branch)
        let _hours = new Date().toLocaleString("id-ID", {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        let NOREG = "";
        let NOMR = "";
        let NO_BUKTI_LAYANAN = "";
        let NO_ANTRIAN_DOKTER = "";

        if (this.state.alldatas.length == 0) {
            let generated_number = "0001";
            NOREG = this.state.chooseKonsultasi?.kode + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('YYMM') + generated_number + this.state.chooseKonsultasi?.branch;
            NOMR = this.state.chooseKonsultasi?.branch + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('MMYY') + generated_number;
            NO_BUKTI_LAYANAN = generated_number + "-" + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('DDMMYY') + "-" + moment(this.state.peserta_dateReg + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('hhmm') + "-" + this.state.chooseKonsultasi?.branch;
            NO_ANTRIAN_DOKTER = this.state.chooseKonsultasi?.kode + generated_number;
        } else {

            // np mr
            var _final_NOREG = "";
            if (this.state.alldatas[0].NOREG.slice(-1) == this.state.chooseKonsultasi?.branch) {
                _final_NOREG = this.generateNumber(this.state.lastNOREG.toString());
            } else {
                var _matchVal = this.state.chooseKonsultasi?.branch;
                var branchOnly = this.state.alldatas.filter(function (e) {
                    return e.NOREG.slice(-1) == _matchVal;
                });

                console.log("branchOnlyMR", branchOnly);

                if (branchOnly.length == 0) {
                    _final_NOREG = "0001";
                } else {
                    let lastNumber_NOREG = branchOnly[0].NOREG;
                    let ln_NOREG = lastNumber_NOREG.slice(6);
                    let lnf_NOREG = ln_NOREG.match(/\d/g).join("");
                    _final_NOREG = this.generateNumber(lnf_NOREG.toString());
                }
            }

            // NOMR klinik
            var _final_NOMR = "";
            var _matchVal = this.state.chooseKonsultasi?.branch;
            var branchOnly = this.state.alldatas.filter(function (e) {
                return e.NOMR.charAt(0) == _matchVal;
            });

            console.log("branchOnlyNOMR", branchOnly);

            if (branchOnly.length == 0) {
                _final_NOMR = "0001";
            } else {
                var maxNumber = [];
                branchOnly.map((item, index) => {
                    let x = item.NOMR.slice(5);
                    maxNumber.push(parseInt(x))
                })

                console.log("maxNumberNOMR", maxNumber);
                var max_of_array = Math.max.apply(Math, maxNumber);
                console.log("max_of_array", max_of_array);
                var pad_number = (max_of_array).toString().padStart(4, "0")
                _final_NOMR = this.generateNumber(pad_number.toString());
            }


            // no bukti layanan
            var _final_NO_BUKTI_LAYANAN = "";

            // console.log("iscurrentDate",iscurrentDate);
            if (this.state.alldatas[0].NO_BUKTI_LAYANAN.slice(-1) == this.state.chooseKonsultasi?.branch) {
                var iscurrentDate = moment().isSame(this.state.lastTGL_LAYANAN, 'day');
                console.log("iscurrentDate", iscurrentDate);
                if (!iscurrentDate) {
                    _final_NO_BUKTI_LAYANAN = "0001";
                } else if (iscurrentDate) {
                    _final_NO_BUKTI_LAYANAN = this.generateNumber(this.state.lastNO_BUKTI_LAYANAN.toString());
                } else { }
            } else {
                var _matchVal = this.state.chooseKonsultasi?.branch;
                var branchOnly = this.state.alldatas.filter(function (e) {
                    return e.NO_BUKTI_LAYANAN.slice(-1) == _matchVal;
                });

                console.log("branchOnlyLayanan", branchOnly);

                if (branchOnly.length == 0) {
                    _final_NO_BUKTI_LAYANAN = "0001";
                } else {
                    let lastNumber_NO_BUKTI_LAYANAN = branchOnly[0].NO_BUKTI_LAYANAN;
                    let ln_NO_BUKTI_LAYANAN = lastNumber_NO_BUKTI_LAYANAN.substring(0, lastNumber_NO_BUKTI_LAYANAN.indexOf('-'));
                    var iscurrentDate = moment().isSame(branchOnly[0].TGL_LAYANAN, 'day');
                    if (!iscurrentDate) {
                        _final_NO_BUKTI_LAYANAN = "0001";
                    } else if (iscurrentDate) {
                        _final_NO_BUKTI_LAYANAN = this.generateNumber(ln_NO_BUKTI_LAYANAN.toString());
                    } else { }

                }
            }

            // no antrian dokter
            var _final_NO_ANTRIAN_DOKTER = "";

            if (this.state.chooseKonsultasi?.branch == localStorage.getItem("branch")) {

                if (this.state.selectedDay) {
                    var iscurrentDate = moment(moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD")).isSame(moment(this.state.lastTGL_LAYANAN).format('YYYY-MM-DD'));
                    // if (!iscurrentDate) {
                    let match = this.state.alldatas.filter(x => x.branch_code == this.state.chooseKonsultasi?.branch && moment(moment.utc(x.TGL_LAYANAN)).local().format("YYYY-MM-DD") == moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD"));
                    if (match.length > 0) {
                        let match2 = match.filter(x => x.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == this.state.chooseKonsultasi?.kode);
                        if (match2.length > 0) {
                            let number = match2[0].ANTRIAN_DOKTER.match(/\d+/g);
                            _final_NO_ANTRIAN_DOKTER = this.generateNumber(number.toString())
                        } else {
                            _final_NO_ANTRIAN_DOKTER = "0001";
                        }

                    } else {
                        _final_NO_ANTRIAN_DOKTER = "0001";
                    }
                    // } else if (iscurrentDate) {
                    //     _final_NO_ANTRIAN_DOKTER = this.generateNumber(this.state.lastNO_BUKTI_ANTRIAN_DOKTER.toString());
                    // } else { }

                } else {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "error",
                            title: "Tanggal Layanan Harus Diisi!",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                        .then(function () { return });
                }
            }

            // if (this.state.lastBRANCH_ANTRIAN_DOKTER == this.state.chooseKonsultasi?.branch) {
            //     if (this.state.lastKODE_ANTRIAN_DOKTER == this.state.chooseKonsultasi?.kode) {
            //         if (this.state.selectedDay) {
            //             var iscurrentDate = moment(moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD")).isSame(moment(this.state.lastTGL_LAYANAN).format('YYYY-MM-DD'));
            //             if (!iscurrentDate) {
            //                 let match = this.state.alldatas.filter(x => x.branch_code == this.state.chooseKonsultasi?.branch && moment(moment.utc(x.TGL_LAYANAN)).local().format("YYYY-MM-DD") == moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD"));
            //                 if (match.length > 0) {
            //                     let match2 = match.filter(x => x.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == this.state.chooseKonsultasi?.kode);
            //                     if (match2.length > 0) {
            //                         let number = match2[0].ANTRIAN_DOKTER.match(/\d+/g);
            //                         _final_NO_ANTRIAN_DOKTER = this.generateNumber(number.toString())
            //                     } else {
            //                         _final_NO_ANTRIAN_DOKTER = "0001";
            //                     }

            //                 } else {
            //                     _final_NO_ANTRIAN_DOKTER = "0001";
            //                 }
            //             } else if (iscurrentDate) {
            //                 _final_NO_ANTRIAN_DOKTER = this.generateNumber(this.state.lastNO_BUKTI_ANTRIAN_DOKTER.toString());
            //             } else { }

            //         } else {
            //             swalWithBootstrapButtons
            //                 .fire({
            //                     icon: "error",
            //                     title: "Tanggal Layanan Harus Diisi!",
            //                     toast: true,
            //                     position: "top-end",
            //                     showConfirmButton: false,
            //                     timer: 3000,
            //                     timerProgressBar: true,
            //                     didOpen: (toast) => {
            //                         toast.addEventListener("mouseenter", Swal.stopTimer);
            //                         toast.addEventListener("mouseleave", Swal.resumeTimer);
            //                     },
            //                 })
            //                 .then(function () { return });
            //         }


            //     } else {
            //         var _matchVal = this.state.chooseKonsultasi?.kode;
            //         var kodeOnly = this.state.alldatas.filter(function (e) {
            //             return e.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == _matchVal;
            //         });

            //         // tambahin filternya kayak diatas

            //         if (kodeOnly.length == 0) {
            //             _final_NO_ANTRIAN_DOKTER = "0001";
            //         } else {
            //             let ln_NO_BUKTI_ANTRIAN_DOKTER = kodeOnly[0].ANTRIAN_DOKTER.match(/\d+/g);
            //             var iscurrentDate = moment().isSame(kodeOnly[0].TGL_LAYANAN, 'day');
            //             if (!iscurrentDate) {
            //                 _final_NO_ANTRIAN_DOKTER = "0001";
            //             } else if (iscurrentDate) {
            //                 _final_NO_ANTRIAN_DOKTER = this.generateNumber(ln_NO_BUKTI_ANTRIAN_DOKTER.toString());
            //             } else { }
            //         }
            //     }

            // } else {
            //     var _matchVal = this.state.chooseKonsultasi?.branch;
            //     var branchOnly = this.state.alldatas.filter(function (e) {
            //         return e.NO_BUKTI_LAYANAN.slice(-1) == _matchVal;
            //     });

            //     var _matchValKode = this.state.chooseKonsultasi?.kode;

            //      // tambahin filternya kayak diatas

            //     if (branchOnly) {
            //         var kodeOnly = branchOnly.filter(function (e) {
            //             return e.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == _matchValKode;
            //         });

            //         if (kodeOnly.length == 0) {
            //             _final_NO_ANTRIAN_DOKTER = "0001";
            //         } else {
            //             let ln_NO_BUKTI_ANTRIAN_DOKTER = kodeOnly[0].ANTRIAN_DOKTER.match(/\d+/g);
            //             var iscurrentDate = moment().isSame(kodeOnly[0].TGL_LAYANAN, 'day');
            //             if (!iscurrentDate) {
            //                 _final_NO_ANTRIAN_DOKTER = "0001";
            //             } else if (iscurrentDate) {
            //                 _final_NO_ANTRIAN_DOKTER = this.generateNumber(ln_NO_BUKTI_ANTRIAN_DOKTER.toString());
            //             } else { }
            //         }
            //     } else {
            //         _final_NO_ANTRIAN_DOKTER = "0001";
            //     }
            // }


            console.log("ini last number NOREG FINAL", _final_NOREG);
            console.log("ini last number NOMR FINAL", _final_NOMR);
            console.log("ini last number NO_BUKTI_LAYANAN", _final_NO_BUKTI_LAYANAN);
            console.log("ini last number NO_ANTRIAN_DOKTER", _final_NO_ANTRIAN_DOKTER);

            NOREG = this.state.chooseKonsultasi?.kode + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('YYMM') + _final_NOREG + this.state.chooseKonsultasi?.branch;
            NOMR = this.state.chooseKonsultasi?.branch + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('MMYY') + _final_NOMR;
            NO_BUKTI_LAYANAN = _final_NO_BUKTI_LAYANAN + "-" + moment(this.state.peserta_dateReg, 'YYYY-MM-DD').format('DDMMYY') + "-" + moment(this.state.peserta_dateReg + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('hhmm') + "-" + this.state.chooseKonsultasi?.branch;
            // NO_ANTRIAN = this.state.chooseKonsultasi?.branch + _final_NO_BUKTI_LAYANAN;
            // NO_ANTRIAN = "RK" + _final_NO_BUKTI_LAYANAN;
            NO_ANTRIAN_DOKTER = this.state.chooseKonsultasi?.kode + _final_NO_ANTRIAN_DOKTER;
            // alert(NO_BUKTI_LAYANAN);
        }


        let thisNOMR = this.state.ExistingRecord ? this.state.chooseNOMR?.value : NOMR;

        // let _informasi = "";

        // if (this.state.ExistingRecord) {
        //     // kondisi cek apakah NOMR sudah exam
        //     if (this.state.historyCount.length == 0) {
        //         _informasi = "Belum mendapatkan pelayanan medis";
        //     } else {
        //         _informasi = "Dokter sudah mengisi pengkajian"
        //     }

        // } else {
        //     _informasi = "Belum mendapatkan pelayanan medis";
        // }


        // ini save
        let f = new FormData();
        f.append('namaPasien', this.state.peserta_namaPasien);
        // f.append('NOMR', thisNOMR);

        // sebelum bridging
        f.append('NOMR', this.state.peserta_NOMR);

        f.append('NIK', this.state.peserta_NIK);
        f.append('NOREG', NOREG);
        f.append('dateReg', moment(this.state.peserta_dateReg + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
        f.append('jenisKelamin', this.state.peserta_jenisKelamin);
        f.append('tempatLahir', this.state.peserta_tempatLahir);
        f.append('alamat', this.state.peserta_alamat);

        f.append('nasabah', "Pasien Umum");
        f.append('noBuktiLayanan', NO_BUKTI_LAYANAN);
        f.append('dpjp', this.state.chooseDokterKonsultasi?.value);
        f.append('prioritas', this.state.peserta_prioritas);
        f.append('tanggalLahir', moment(moment.utc(this.state.peserta_tanggalLahir)).local().format("YYYY-MM-DD"));
        f.append('informasi', this.state.peserta_informasi);
        // f.append('antrian', NO_ANTRIAN);
        f.append('petugasInput', Cookies.get('biomedika-csrf'));
        f.append('branchCode', this.state.chooseKonsultasi?.branch);
        f.append('noTelp', this.state.peserta_noTelp);
        f.append('email', this.state.peserta_email);
        f.append('dateReturn', "0000-00-00");
        f.append('idKonsultasi', this.state.chooseKonsultasi?.value);
        f.append('notelp2', document.getElementById("notelp2").value);
        f.append('email2', document.getElementById("email2").value);

        f.append('pekerjaan', this.state.peserta_pekerjaan);
        f.append('riwayatKeluhanUtama', this.state.peserta_riwayatKeluhanUtama);
        f.append('riwayatPenyakitKeluarga', this.state.peserta_riwayatPenyakitKeluarga);
        f.append('riwayatPenyakitDahulu', this.state.peserta_riwayatPenyakitDahulu);
        f.append('riwayatAlergiObat', this.state.peserta_riwayatAlergiObat);

        f.append('jamLayanan', this.state.peserta_jamLayanan);

        if (this.state.selectedDay) {
            f.append('tglLayanan', moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD"));
        }

        if (this.state.chooseKonsultasi?.branch != localStorage.getItem("branch")) {
            // alert(localStorage.getItem("name"));

            let branch = this.state.optBranch.find(function (item, i) {
                return item.value === localStorage.getItem("branch")
            });

            f.append('user_request', localStorage.getItem("name"));
            f.append('branch_request', branch.label);
            f.append('request_branch', localStorage.getItem("branch"));
            // f.append('request_status', "Sedang diproses!");
            f.append('request_status', "Disetujui");

            f.append("user_selected", JSON.stringify(this.state.user_selected))
            f.append('namakonsultasi', this.state.chooseKonsultasi?.nama + " (" + this.state.chooseDokterKonsultasi?.label + ")");
            f.append('antrianDokter', "");
        } else {
            f.append('request_branch', '');
            f.append('request_status', '');

            var iscurrentDate = moment(moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD")).isSame(moment().format('YYYY-MM-DD'));
            if (iscurrentDate) {
                // f.append('antrianDokter', NO_ANTRIAN_DOKTER);
                f.append('antrianDokter', '');
            } else {
                f.append('antrianDokter', '');
            }
        }

        if (this.state.returnDateRequestMode) {
            f.append('selectID_returnDateRequest', this.state.selectID_returnDateRequest);
            f.append('selectStatus_returnDateRequest', this.state.selectStatus_returnDateRequest);
        }

        f.append('regStatus', 'klinik');

        // // pembayaran
        // // f.append('konsultasi', this.state.chooseKonsultasi?.value);
        // // f.append('hargaKonsultasi', this.state.chooseKonsultasi?.price);
        // // f.append('metodePembayaran', this.state.choosePembayaran?.value);
        // f.append('konsultasi', 1);
        // f.append('hargaKonsultasi', "");
        // f.append('metodePembayaran', "");
        // // f.append('tglPembayaran', moment(this.state.peserta_tglPembayaran + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
        // f.append('tglPembayaran', "");
        // f.append('statusPembayaran', "BELUM LUNAS");
        // f.append('keteranganBiayaKonsultasi', "");

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        console.log("tanggal terpilih", moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD"))

        if (this.state.peserta_namaPasien == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Nama Peserta Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        else if (this.state.chooseKonsultasi?.value == 0 || this.state.chooseDokterKonsultasi?.value == undefined) {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Poli/Dokter Harus Dipilih!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        // else if (this.state.ExistingRecord && thisNOMR == undefined) {
        //     swalWithBootstrapButtons
        //         .fire({
        //             icon: "error",
        //             title: "Terjadi Kesalahan!",
        //             toast: true,
        //             position: "top-end",
        //             showConfirmButton: false,
        //             timer: 3000,
        //             timerProgressBar: true,
        //             didOpen: (toast) => {
        //                 toast.addEventListener("mouseenter", Swal.stopTimer);
        //                 toast.addEventListener("mouseleave", Swal.resumeTimer);
        //             },
        //         })
        //         .then(function () { window.location.reload() });
        // } 
        // sebelum bridging 
        else if (this.state.peserta_NOMR == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "NOMR Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        else if (this.state.selectedDay == undefined || !this.state.selectedDay) {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Tanggal Layanan Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else if (this.state.peserta_jamLayanan == undefined || !this.state.peserta_jamLayanan) {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Jam Layanan Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else {

            let _NOREG = '"' + NOREG + '"';
            axios.post(uAPIlocal + `/api/v1/patient/checknoreg?noreg=${_NOREG}`)
                .then(function (response) {
                    console.log(response, "this is response")
                    return response.data;
                })
                .then(response => {
                    console.log('response.results1', response.results.length);
                    console.log('response.results2', NOREG);

                    if (response.results.length > 0) {
                        alert("terjadi kesalahan, ulangi klik tombol save atau refresh halaman")
                        this.getAllPatientForNOMR();
                    } else {

                        axios({
                            method: "post",
                            url: uAPIlocal + "/api/v1/master_patient",
                            data: f,
                            headers: { 'content-type': 'multipart/form-data' }
                        })
                            .then((response) => {
                                console.log("ini res", response);
                                let data = response.data;

                                if (data.status == 406) {
                                    swalWithBootstrapButtons
                                        .fire({
                                            icon: "error",
                                            title: data.message,
                                            toast: true,
                                            position: "top-end",
                                            showConfirmButton: false,
                                            timer: 1000,
                                            timerProgressBar: true,
                                            didOpen: (toast) => {
                                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                                            },
                                        })
                                } else if (data.status == 200) {
                                    swalWithBootstrapButtons
                                        .fire({
                                            icon: "success",
                                            title: data.message,
                                            toast: true,
                                            position: "top-end",
                                            showConfirmButton: false,
                                            timer: 1000,
                                            timerProgressBar: true,
                                            didOpen: (toast) => {
                                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                                            },
                                        })
                                        .then(function () {

                                        });

                                    this.handleCloseModalForm();
                                    this.locationReload();
                                }

                            })
                            .catch((e) => {
                                console.error(e);
                            });

                    }
                })
                .catch(function (error) {
                    console.log(error);
                });



        }

    }


    update_v2() {

        let f = new FormData();
        f.append('ID_REG', this.state.peserta_idReg);
        f.append('namaPasien', this.state.peserta_namaPasien);
        f.append('NIK', this.state.peserta_NIK);
        f.append('NOREG', this.state.peserta_NOREG);
        f.append('dateReg', moment(this.state.peserta_dateReg + " " + this.state.dateRegHour, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD hh:mm:ss'));
        f.append('jenisKelamin', this.state.peserta_jenisKelamin);
        f.append('tempatLahir', this.state.peserta_tempatLahir);
        f.append('alamat', this.state.peserta_alamat);
        f.append('tglLayanan', moment(moment.utc(this.state.peserta_tglLayanan)).local().format("YYYY-MM-DD"));
        f.append('nasabah', "Pasien Umum");
        f.append('noBuktiLayanan', this.state.peserta_noBuktiLayanan);
        f.append('dpjp', this.state.peserta_dpjp);
        f.append('prioritas', this.state.peserta_prioritas);
        f.append('tanggalLahir', moment(moment.utc(this.state.peserta_tanggalLahir)).local().format("YYYY-MM-DD"));
        f.append('informasi', this.state.peserta_informasi);
        // f.append('antrian', this.state.peserta_antrian);
        f.append('petugasInput', this.state.peserta_petugas);
        f.append('branchCode', this.state.chooseBranch?.value);
        f.append('noTelp', this.state.peserta_noTelp);
        f.append('email', this.state.peserta_email);
        f.append('pekerjaan', this.state.peserta_pekerjaan);
        f.append('riwayatKeluhanUtama', this.state.peserta_riwayatKeluhanUtama);
        f.append('riwayatPenyakitKeluarga', this.state.peserta_riwayatPenyakitKeluarga);
        f.append('riwayatPenyakitDahulu', this.state.peserta_riwayatPenyakitDahulu);
        f.append('riwayatAlergiObat', this.state.peserta_riwayatAlergiObat);
        f.append('jamLayanan', this.state.peserta_jamLayanan);
        f.append('mode', 'registrasi');
        f.append('jsonRow', JSON.stringify([]));
        if (Cookies.get('biomedika-level') == 3) {
            f.append('notelp2', document.getElementById("notelp2").value);
            f.append('email2', document.getElementById("email2").value);
        } else {
            f.append('notelp2', document.getElementById("notelp2").value);
            f.append('email2', document.getElementById("email2").value);
        }

        var d = new Date(this.state.peserta_dateReturn);
        // alert(d);
        if (d == 'Invalid Date') {
            f.append('dateReturn', "0000-00-00");
        } else {
            f.append('dateReturn', moment(moment.utc(this.state.peserta_dateReturn)).local().format("YYYY-MM-DD"));
        }


        if (this.state.chooseKonsultasi?.branch == localStorage.getItem("branch") || Cookies.get('biomedika-level') == 3) {
            f.append('request_branch', this.state.peserta_requestBranch);
            f.append('request_status', this.state.peserta_requestStatus);
        }

        if (this.state.editRequestStatus) {
            console.log("yang dipilih", moment(moment.utc(this.state.peserta_tglLayanan)).local().format("YYYY-MM-DD"));
            console.log("yang lama", moment(moment.utc(this.state.peserta_tglLayananBeforeReschedule)).local().format("YYYY-MM-DD"))
            if (moment(moment.utc(this.state.peserta_tglLayanan)).local().format("YYYY-MM-DD") != moment(moment.utc(this.state.peserta_tglLayananBeforeReschedule)).local().format("YYYY-MM-DD")) {
                f.append('antrianDokter', "");
            } else {
                f.append('antrianDokter', this.state.peserta_antrianDokter);
            }
        } else {
            f.append('antrianDokter', this.state.peserta_antrianDokter);
        }


        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        if (this.state.peserta_namaPasien == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Nama Peserta Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        // sebelum bridging 
        else if (this.state.peserta_NOMR == "") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "NOMR Harus Diisi!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        }
        else {

            axios({
                method: "put",
                url: uAPIlocal + "/api/v1/master_patient",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini res", response);
                    let data = response.data;

                    if (data.status == 406) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "error",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                    } else if (data.status == 200) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "success",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                            .then(function () {

                            });


                        this.handleCloseModalForm();
                        this.locationReload();
                    }



                })
                .catch((e) => {
                    console.error(e);
                });

        }
    }

    update_v3() {

        let _hours = new Date().toLocaleString("id-ID", {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        let f = new FormData();
        f.append('ID_REGISTRASI', this.state.dataDetail.ID_REGISTRASI);
        f.append('konsultasi', this.state.chooseKonsultasi?.value);

        if (this.state.peserta_pembayaranKonsultasiType == 1) {
            // f.append('hargaKonsultasi', ((25 / 100) * this.state.chooseKonsultasi?.price));
            f.append('hargaKonsultasi', 0);
        } else if (this.state.peserta_pembayaranKonsultasiType == 0) {
            f.append('hargaKonsultasi', this.state.chooseKonsultasi?.price);
        } else if (this.state.peserta_pembayaranKonsultasiType == 2) {
            let total = this.state.chooseKonsultasi?.price - ((this.state.peserta_pembayaranDiskon / 100) * this.state.chooseKonsultasi?.price);
            f.append('hargaKonsultasi', total);
        }
        else if (this.state.peserta_pembayaranKonsultasiType == 3) {
            f.append('hargaKonsultasi', 0);
        }
        else { }

        f.append('metodePembayaran', this.state.choosePembayaran?.value);
        f.append('tglPembayaran', moment(this.state.peserta_tglPembayaran + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
        // f.append('tglPembayaran', moment(this.state.peserta_dateReg + " " + _hours, 'YYYY-MM-DD hh.mm.ss').format('YYYY-MM-DD hh:mm:ss'));
        f.append('statusPembayaran', this.state.peserta_statusPembayaran);
        f.append('keteranganBiayaKonsultasi', this.state.peserta_ketBiayaKonsul);
        f.append('receivedFrom', this.state.peserta_receivedFrom);
        // f.append('statusSelesai', this.state.peserta_statusSelesai);


        if (this.state.peserta_idPembayaran) {
            f.append('idPembayaran', this.state.peserta_idPembayaran);
        }


        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        axios({
            method: "post",
            url: uAPIlocal + "/api/v1/master_payment",
            data: f,
            headers: { 'content-type': 'multipart/form-data' }
        })
            .then((response) => {
                console.log("ini res", response);
                let data = response.data;

                if (data.status == 406) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "error",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                } else if (data.status == 200) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "success",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                        .then(function () {

                        });

                    // if (this.state.peserta_statusSelesai != "SELESAI") {
                    //     setTimeout(() => {
                    //         this.setState({ modalPemeriksaan: true })
                    //     }, 2000);
                    // }

                    this.handleCloseModalPayment();
                    this.locationReload();




                }


            })
            .catch((e) => {
                console.error(e);
            });
    }

    update_v4(row) {
        console.log("INI UPDATEAN 4", row)

        let chooseKonsultasi = row.NOREG.slice(0, 2);
        let chooseBranch = row.branch_code;
        let NO_ANTRIAN_DOKTER = "";
        if (this.state.alldatas.length == 0) {
            let generated_number = "0001";
            NO_ANTRIAN_DOKTER = chooseBranch + generated_number;
        } else {
            var _final_NO_ANTRIAN_DOKTER = "";

            let match = this.state.alldatas.filter(x => x.branch_code == chooseBranch && moment(moment.utc(x.TGL_LAYANAN)).local().format("YYYY-MM-DD") == moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD"));
            if (match.length > 0) {
                let match2 = match.filter(x => x.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == chooseKonsultasi);
                if (match2.length > 0) {
                    let number = match2[0].ANTRIAN_DOKTER.match(/\d+/g);
                    _final_NO_ANTRIAN_DOKTER = this.generateNumber(number.toString())
                } else {
                    _final_NO_ANTRIAN_DOKTER = "0001";
                }

            } else {
                _final_NO_ANTRIAN_DOKTER = "0001";
            }

            NO_ANTRIAN_DOKTER = chooseKonsultasi + _final_NO_ANTRIAN_DOKTER;
        }

        // alert(NO_ANTRIAN_DOKTER);

        let f = new FormData();
        f.append('ID_REG', row.ID_REGISTRASI);
        f.append('antrianDokter', NO_ANTRIAN_DOKTER);
        f.append('jsonRow', JSON.stringify([]));
        f.append('mode', 'antrian');

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        axios({
            method: "put",
            url: uAPIlocal + "/api/v1/master_patient",
            data: f,
            headers: { 'content-type': 'multipart/form-data' }

        })
            .then((response) => {
                console.log("ini res", response);
                let data = response.data;

                if (data.status == 406) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "error",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                } else if (data.status == 200) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "success",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                        .then(function () {

                        });

                    this.handleCloseModalForm();
                    this.locationReload();
                }

            })
            .catch((e) => {
                console.error(e);
            });


    }


    // tanggal balik konsul hasil lab
    update_v5() {

        let f = new FormData();
        let _d = moment(moment.utc(this.state.peserta_dateReturn)).local().format("YYYY-MM-DD");
        f.append('ID_REG', this.state.peserta_idReg);
        f.append('status', this.state.dataDetail.STATUS)
        f.append('dateReturn', _d);
        f.append('mode', 'return_date');
        f.append('jsonRow', JSON.stringify([]));

        // alert(moment(moment.utc(this.state.peserta_dateReturn)).local().format("YYYY-MM-DD"));

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        if (_d == "Invalid date") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Pilih Tanggal Balik!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else {
            axios({
                method: "put",
                url: uAPIlocal + "/api/v1/master_patient",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini res", response);
                    let data = response.data;

                    if (data.status == 406) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "error",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                    } else if (data.status == 200) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "success",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                            .then(function () {

                            });

                        this.handleCloseModalForm();
                        this.locationReload();
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        }




    }

    // daftar ulang
    update_v6(row) {
        console.log("INI UPDATEAN 6", row)

        let chooseKonsultasi = row.NOREG.slice(0, 2);
        let chooseBranch = row.branch_code;
        let NO_ANTRIAN_DOKTER = "";
        if (this.state.alldatas.length == 0) {
            let generated_number = "0001";
            NO_ANTRIAN_DOKTER = chooseBranch + generated_number;
        } else {
            var _final_NO_ANTRIAN_DOKTER = "";

            let match = this.state.alldatas.filter(x => x.branch_code == chooseBranch && moment(moment.utc(x.TGL_LAYANAN)).local().format("YYYY-MM-DD") == moment(moment.utc(row.RETURN_DATE)).local().format("YYYY-MM-DD"));
            if (match.length > 0) {
                let match2 = match.filter(x => x.ANTRIAN_DOKTER.match(/[a-zA-Z]+/g) == chooseKonsultasi);
                if (match2.length > 0) {
                    let number = match2[0].ANTRIAN_DOKTER.match(/\d+/g);
                    _final_NO_ANTRIAN_DOKTER = this.generateNumber(number.toString())
                } else {
                    _final_NO_ANTRIAN_DOKTER = "0001";
                }

            } else {
                _final_NO_ANTRIAN_DOKTER = "0001";
            }

            NO_ANTRIAN_DOKTER = chooseKonsultasi + _final_NO_ANTRIAN_DOKTER;
        }


        let f = new FormData();
        f.append('ID_REG', row.ID_REGISTRASI);
        f.append('antrianDokter', NO_ANTRIAN_DOKTER);
        f.append('mode', 'daftar_ulang');
        f.append('jsonRow', JSON.stringify(row));

        if (this.state.returnDateRequestMode) {
            f.append('selectID_returnDateRequest', this.state.selectID_returnDateRequest);
            f.append('selectStatus_returnDateRequest', this.state.selectStatus_returnDateRequest);
        }

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        axios({
            method: "put",
            url: uAPIlocal + "/api/v1/master_patient",
            data: f,
            headers: { 'content-type': 'multipart/form-data' }
        })
            .then((response) => {
                console.log("ini res", response);
                let data = response.data;

                if (data.status == 406) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "error",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                } else if (data.status == 200) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "success",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                        .then(function () {

                        });

                    this.handleCloseModalForm();
                    this.locationReload();
                }

            })
            .catch((e) => {
                console.error(e);
            });


    }


    update_v7(row) {

        let f = new FormData();
        f.append('ID_REG', row.ID_REGISTRASI);
        f.append('mode', 'cancel');
        f.append('jsonRow', JSON.stringify([]));

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        axios({
            method: "put",
            url: uAPIlocal + "/api/v1/master_patient",
            data: f,
            headers: { 'content-type': 'multipart/form-data' }
        })
            .then((response) => {
                console.log("ini res", response);
                let data = response.data;

                if (data.status == 406) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "error",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                } else if (data.status == 200) {
                    swalWithBootstrapButtons
                        .fire({
                            icon: "success",
                            title: data.message,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", Swal.stopTimer);
                                toast.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        })
                        .then(function () {

                        });

                    this.handleCloseModalForm();
                    this.locationReload();
                }

            })
            .catch((e) => {
                console.error(e);
            });


    }

    update_v8() {
        let f = new FormData();
        let _d = moment(moment.utc(this.state.peserta_janjiHasil)).local().format("YYYY-MM-DD");
        f.append('ID_REG', this.state.peserta_idReg);
        f.append('janjiHasil', _d);
        f.append('mode', 'janji_hasil');
        f.append('jsonRow', JSON.stringify([]));

        for (var pair of f.entries()) {
            console.log(pair[0] + ', ' + pair[1]);
        }

        if (_d == "Invalid date") {
            swalWithBootstrapButtons
                .fire({
                    icon: "error",
                    title: "Pilih Tanggal Balik!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                    },
                })
                .then(function () { });
        } else {
            axios({
                method: "put",
                url: uAPIlocal + "/api/v1/master_patient",
                data: f,
                headers: { 'content-type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log("ini res", response);
                    let data = response.data;

                    if (data.status == 406) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "error",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                    } else if (data.status == 200) {
                        swalWithBootstrapButtons
                            .fire({
                                icon: "success",
                                title: data.message,
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener("mouseenter", Swal.stopTimer);
                                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                                },
                            })
                            .then(function () {

                            });

                        this.handleCloseModalForm();
                        this.locationReload();
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        }




    }


    changeSelect = (e) => {
        console.log('change', e)
        this.setState({ chooseDept: e })
    }

    changeSelectPeserta = (e) => {
        console.log('change', e)
        this.setState({ choosePeserta: e })
    }

    changeSelectKonsultasi = (e) => {
        console.log('change konsul', e)
        this.setState({ chooseKonsultasi: e })

        // alert(e.value)


        if (e.branch != localStorage.getItem("branch")) {
            this.getUserBranch(1, e.branch);
        }

        this.getDokterKonsultasi(e.value)

        // let indexDokter = this.state.optDokter.findIndex(function (item, i) {
        //     return item.value === e.dokter
        // });

        // this.setState({ chooseDokter: this.state.optDokter[indexDokter] })

    }

    async getJadwal(id) {
        this.setState({
            selectedDay: null,
            disabledDays: [],
        });
        axios.post(uAPIlocal + `/api/v1/jadwaldokter/${id}`)
            .then((res) => {



                const Days = [];
                res.data.results.map(item => (
                    Days.push(moment(item.date).format("YYYY-MM-DD"))
                ))

                console.log("INI JADWAL DOKTER", Days);

                let disabledDays = [];

                this.state.allDays.map((item, index) => {
                    console.log("INI JAKJAKJKA", item);
                    if (Days.includes(item) == false) {
                        disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
                    }
                })

                this.setState({ disabledDays: disabledDays }, () => console.log("ini adalah selectedday", this.state.disabledDays));


            })
            .catch((err) => {
                console.log('err', err)
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else { }
            })
    }

    async getJam(id, date) {
        // this.setState({
        //     selectedDay: null,
        //     disabledDays: [],
        // });
        await axios.post(uAPIlocal + `/api/v1/jamdokter_registrasi/${id}?date=${date}`)
            .then(async (res) => {

                const jam = [];
                res.data.results.map(item => (
                    jam.push(item.jam)
                ))


                let _jamSelected = [];

                var _date = moment(moment.utc(this.state.selectedDay)).local().format("YYYY-MM-DD");

                jam.map(async (item, i) => {

                    var _k = '"' + this.state.chooseKonsultasi?.value + '"';
                    var _d = '"' + _date + '"';
                    var _j = '"' + item + '"';
                    var _url = uAPIlocal + `/api/v1/cekjam/${_k}?d=${_d}&j=${_j}`;
                    let getDetail = await axios.post(_url, { cancelToken: source.token });

                    console.log("ini penantian", getDetail.data.results.length);
                    if (getDetail.data.results.length > 0) {

                        this.setState({
                            opsiJam: [...this.state.opsiJam, {
                                id: i,
                                title: item,
                                disabled: true
                            }]
                        })
                        // _jamSelected.push(
                        //     {
                        //         id: i,
                        //         title: item,
                        //         disabled: true
                        //     }
                        // );
                    } else {

                        this.setState({
                            opsiJam: [...this.state.opsiJam, {
                                id: i,
                                title: item,
                                disabled: false
                            }]
                        })

                        // _jamSelected.push(
                        //     {
                        //         id: i,
                        //         title: item,
                        //         disabled: false
                        //     }
                        // );
                    }

                    // _jamSelected.push(
                    //     {
                    //         id: i,
                    //         title: item,
                    //         disabled: false
                    //     }
                    // )
                })

                this.setState({ opsiJam: _jamSelected })
                console.log("INI JAM DOKTER", jam);

                // let disabledDays = [];

                // this.state.allDays.map((item, index) => {
                //     console.log("INI JAKJAKJKA", item);
                //     if (Days.includes(item) == false) {
                //         disabledDays.push(new Date(moment(item, "YYYY-MM-DD").format("YYYY"), moment(item, "YYYY-MM-DD").format("M") - 1, moment(item, "YYYY-MM-DD").format("DD")))
                //     }
                // })

                // this.setState({ disabledDays: disabledDays }, () => console.log("ini adalah selectedday", this.state.disabledDays));

            })
            .catch((err) => {
                console.log('err', err)
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else { }
            })
    }

    changeSelectBranch = (e) => {
        console.log('change branch', e)
        this.setState({ historyBranchSelected: this.state.chooseBranchPatient?.value, chooseBranchPatient: e, }, () => setTimeout(() => {
            this.locationReload()
        }, 1000))
    }

    changeSelectNOMR = (e) => {
        console.log('change NOMR', e)
        this.setState({ chooseNOMR: e }, () =>
            this.cekNOMRExam(e.value)
        )
        // this.cekNOMRExam(e.value);
    }

    changeSelectDokter = (e) => {
        console.log(e.toString())
        console.log('change', e)
        this.setState({ chooseDokterKonsultasi: e })
        this.getJadwal(e.id);
    }

    changeSelectPembayaran = (e) => {
        console.log('change pembayaran', e)
        this.setState({ choosePembayaran: e })
    }

    changeSelectFilter = (e) => {
        this.setState({ peserta_filter: e }, () => setTimeout(() => {
            this.locationReload()
        }, 1000))
    }


    // onChangeJam = (item) => {
    //     this.setState({ opsiJam: this.state.opsiJam.map(e => e.id === item.id ? { ...e, checked: !item.checked } : e), peserta_jamLayanan: item.title }, () => alert(this.state.peserta_jamLayanan));
    // }


    handleSelect(key) {
        this.setState({ tabkey: key });
    }



    handleDayClick(day, { selected }) {

        this.setState({
            selectedDay: selected ? undefined : day,
        }, () => this.getJam(this.state.chooseDokterKonsultasi?.id, moment(day).format("YYYY-MM-DD")));
    }

    handleDayClickReturn(day, { selected }) {
        this.setState({
            peserta_dateReturn: selected ? undefined : day,
        });
    }

    handleDayClickReschedule(day, { selected }) {
        this.setState({
            peserta_tglLayanan: selected ? undefined : day,
        });
    }


    deleteRowPatient(id, n) {
        this.setState({ _delSwalPatient: true, _editFormActive: false })
        Swal.fire({
            text: "Apakah Anda yakin menghapus " + n + "?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Hapus",
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteDataPatient(id);
            } else {
                this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            }
        });
    }

    deleteDataPatient(p, t) {
        let f = new FormData();
        f.append('ID_REGISTRASI', p);
        axios({
            method: "delete",
            url: uAPIlocal + "/api/v1/master_patient/",
            data: f,
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then((response) => {
                swalWithBootstrapButtons
                    .fire({
                        icon: "success",
                        title: "berhasil dihapus",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 1000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    })
                    .then(function () {
                        // location.reload()
                    });

                this.locationReload();
                this.resetForm();


            })
            .catch((e) => {
                console.error(e);
            });
    };


    sendEmail(data) {
        console.log("ini data untuk email", data)
        // this.setState({ _delSwalPatient: true, _editFormActive: false })
        Swal.fire({
            text: "Kirim email ke " + data.EMAIL + "?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Kirim",
        }).then((result) => {
            if (result.isConfirmed) {
                this.sendEmailPatient(data)
            } else {
                this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            }
        });

    }

    sendEmailPatient(data) {
        axios
            .post(uAPIlocal + "/api/v1/sendmail", {
                username: data.NAMA_PASIEN,
                tomail: data.EMAIL,
                _json: data,
            })
            .then((response) => {
                if (response.data.msg === "success") {

                } else if (response.data.msg === "fail") {
                    alert("Oops, something went wrong. Try again");

                }
            });
    };

    generateTicketConfirm(row) {
        this.setState({ _delSwalPatient: true, _editFormActive: false })
        Swal.fire({
            text: "Generate Tiket?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Ok",
        }).then((result) => {
            if (result.isConfirmed) {
                this.update_v4(row);
            } else {
                this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            }
        });
    }

    daftarUlangConfirm(row) {
        this.setState({ _delSwalPatient: true, _editFormActive: false })
        Swal.fire({
            text: "Daftar ulang Pasien untuk Konsultasi Laboratorium?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Ok",
        }).then((result) => {
            if (result.isConfirmed) {
                this.update_v6(row);
            } else {
                this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            }
        });
    }

    cancelConfirm(row) {
        this.setState({ _delSwalPatient: true, _editFormActive: false })
        Swal.fire({
            text: "Batalkan Registrasi?",
            toast: true,
            showCancelButton: true,
            confirmButtonText: "Ok",
        }).then((result) => {
            if (result.isConfirmed) {
                this.update_v7(row);
            } else {
                this.setState({ showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true })
            }
        });
    }


    locationReload() {
        this.setState({ tableInbox: false })
        this.getPatient();
        // setTimeout(() => {
        //     this.setState({
        //         tableInbox: true
        //     })
        // }, 2000);
    };

    //   batas fungsi

    render() {

        if (this.state.redirctTo) {
            localStorage.clear();
            sessionStorage.clear();
            Cookies.remove("biomedika-login", { path: '/', domain: '.biomedika.co.id' })
            // Cookies.remove("biomedika-login", { path: '/' })
        } else { }

        const emptyDataMessage = () => { return (<p style={{ textAlign: 'center', marginTop: '20px' }}>Tidak ada data</p>); }
        const onChangeJamSelect = (e) => {
            console.log(`radio checked:${e.target.value}`);
            this.setState({ peserta_jamLayanan: e.target.value });
            // this.setState({ opsiJam: this.state.opsiJam.map(e => e.id === item.id ? { ...e, checked: !item.checked } : e), peserta_jamLayanan: item.title }, () => alert(this.state.peserta_jamLayanan));
        };

        const { tableInbox } = this.state;
        const columns = [
            {
                dataField: "id",
                text: "",
                style: (cell, row, rowIndex) => {

                    if (row.request_status == "Sedang diproses!") {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            width: "20px",
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            width: "20px",
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }

                },
                headerAttrs: {
                    hidden: false
                },
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', width: '20px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    const _edit = (event) => {
                        console.log("happyhappy edit", row);

                        let indexKonsultasi = this.state.optKonsultasi.findIndex(function (item, i) {
                            return item.value == row.ID_KONSULTASI
                        });


                        let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                            return item.value === row.branch_code
                        });

                        let indexDokter = this.state.optDokter.findIndex(function (item, i) {
                            return item.value === row.DPJP
                        });

                        let indexPembayaran = this.state.optPembayaran.findIndex(function (item, i) {
                            return item.value === row.METODE_PEMBAYARAN
                        });


                        setTimeout(() => {
                            if (Cookies.get('biomedika-level') == 3) {
                                document.getElementById("notelp2").value = row.NO_TELP2;
                                document.getElementById("email2").value = row.EMAIL2;
                            }
                        }, 1000);

                        this.getDokterKonsultasi(row.ID_KONSULTASI)

                        this.setState({
                            modalForm: true,
                            peserta_idReg: row.ID_REGISTRASI,
                            peserta_namaPasien: row.NAMA_PASIEN,
                            peserta_NOMR: row.NOMR,
                            peserta_NOREG: row.NOREG,
                            peserta_NIK: row.NIK,

                            // peserta_dateReg: moment(row.DATE_REGISTRASI, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            // peserta_jenisKelamin: row.JENIS_KELAMIN,
                            // peserta_tempatLahir: row.TEMPAT_LAHIR,
                            // peserta_alamat: row.ALAMAT,
                            // peserta_tglLayanan: moment(row.TGL_LAYANAN, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                            // peserta_nasabah: row.NASABAH,
                            // peserta_noBuktiLayanan: row.NO_BUKTI_LAYANAN,
                            // peserta_dpjp: row.DPJP,
                            // peserta_prioritas: row.PRIORITAS,
                            // peserta_tanggalLahir: row.TANGGAL_LAHIR,
                            // peserta_informasi: row.INFORMASI,
                            // peserta_antrian: row.ANTRIAN,
                            // peserta_petugas: row.PETUGAS_INPUT,
                            // peserta_petugasName: row.name,
                            // dateRegHour: moment(row.DATE_REGISTRASI, 'hh:mm:ss').format("hh:mm:ss"),
                            // peserta_dateReturn: moment(row.RETURN_DATE, 'YYYY-MM-DD').format("YYYY-MM-DD"),
                            peserta_dateReg: moment(moment.utc(row.DATE_REGISTRASI)).local().format("YYYY-MM-DD"),
                            peserta_jenisKelamin: row.JENIS_KELAMIN,
                            peserta_tempatLahir: row.TEMPAT_LAHIR,
                            peserta_alamat: row.alamatPasien,
                            peserta_tglLayanan: moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD"),
                            peserta_jamLayanan: row.JAM_LAYANAN,
                            peserta_nasabah: row.NASABAH,
                            peserta_noBuktiLayanan: row.NO_BUKTI_LAYANAN,
                            peserta_dpjp: row.DPJP,
                            peserta_prioritas: row.PRIORITAS,
                            peserta_tanggalLahir: row.TANGGAL_LAHIR,
                            peserta_informasi: row.INFORMASI,
                            // peserta_antrian: row.ANTRIAN,
                            peserta_petugas: row.PETUGAS_INPUT,
                            peserta_petugasName: row.name,
                            dateRegHour: moment(moment.utc(row.DATE_REGISTRASI)).local().format("hh:mm:ss"),
                            peserta_dateReturn: moment(moment.utc(row.RETURN_DATE)).local().format("YYYY-MM-DD"),
                            peserta_requestStatus: row.request_status,
                            peserta_requestBranch: row.request_branch,
                            // // peserta_metodePembayaran: row.METODE_PEMBAYARAN,
                            // choosePembayaran: this.state.optPembayaran[indexPembayaran],
                            // peserta_tglPembayaran: moment(row.DATE_PEMBAYARAN, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            // dateStatusPembayaranHour: moment(row.DATE_PEMBAYARAN, 'hh:mm:ss').format("hh:mm:ss"),
                            // peserta_statusPembayaran: row.STATUS,
                            chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                            chooseBranch: this.state.optBranch[indexBranch],
                            chooseDokterKonsultasi: this.state.optDokter[indexDokter],
                            // peserta_idPembayaran: row.ID_PEMBAYARAN,
                            peserta_noTelp: row.NO_TELP,
                            peserta_email: row.EMAIL,
                            peserta_pekerjaan: row.PEKERJAAN,
                            peserta_riwayatKeluhanUtama: row.RIWAYAT_KELUHAN_UTAMA,
                            peserta_riwayatPenyakitKeluarga: row.RIWAYAT_PENYAKIT_KELUARGA,
                            peserta_riwayatPenyakitDahulu: row.RIWAYAT_PENYAKIT_DAHULU,
                            peserta_riwayatAlergiObat: row.RIWAYAT_ALERGI_OBAT,


                            // peserta_ketBiayaKonsul: row.KETERANGAN_BIAYA_KONSULTASI,
                            tabkey: 1,
                            updateBtnV2: true,
                            _editFormActive: true,

                            // chooseDept: this.state.optDept[indexDept],
                        })

                        if (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) {
                            this.setState({
                                editDateReturn: true
                            })
                        }


                    };


                    const _editJ = (event) => {
                        console.log("happyhappy edit", row);

                        let indexKonsultasi = this.state.optKonsultasi.findIndex(function (item, i) {
                            return item.value == row.ID_KONSULTASI
                        });


                        let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                            return item.value === row.branch_code
                        });

                        let indexDokter = this.state.optDokter.findIndex(function (item, i) {
                            return item.value === row.DPJP
                        });


                        setTimeout(() => {
                            if (Cookies.get('biomedika-level') == 3) {
                                document.getElementById("notelp2").value = row.NO_TELP2;
                                document.getElementById("email2").value = row.EMAIL2;
                            }
                        }, 1000);

                        this.getDokterKonsultasi(row.ID_KONSULTASI)

                        this.setState({
                            modalForm: true,
                            peserta_idReg: row.ID_REGISTRASI,
                            peserta_namaPasien: row.NAMA_PASIEN,
                            peserta_NOMR: row.NOMR,
                            peserta_NOREG: row.NOREG,
                            peserta_NIK: row.NIK,
                            peserta_dateReg: moment(moment.utc(row.DATE_REGISTRASI)).local().format("YYYY-MM-DD"),
                            peserta_jenisKelamin: row.JENIS_KELAMIN,
                            peserta_tempatLahir: row.TEMPAT_LAHIR,
                            peserta_alamat: row.alamatPasien,
                            peserta_tglLayanan: moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD"),
                            peserta_jamLayanan: row.JAM_LAYANAN,
                            peserta_nasabah: row.NASABAH,
                            peserta_noBuktiLayanan: row.NO_BUKTI_LAYANAN,
                            peserta_dpjp: row.DPJP,
                            peserta_prioritas: row.PRIORITAS,
                            peserta_tanggalLahir: row.TANGGAL_LAHIR,
                            peserta_informasi: row.INFORMASI,
                            peserta_petugas: row.PETUGAS_INPUT,
                            peserta_janjiHasil: moment(moment.utc(row.JANJI_HASIL)).local().format("YYYY-MM-DD"),
                            peserta_petugasName: row.name,
                            dateRegHour: moment(moment.utc(row.DATE_REGISTRASI)).local().format("hh:mm:ss"),
                            peserta_dateReturn: moment(moment.utc(row.RETURN_DATE)).local().format("YYYY-MM-DD"),
                            peserta_requestStatus: row.request_status,
                            peserta_requestBranch: row.request_branch,
                            chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                            chooseBranch: this.state.optBranch[indexBranch],
                            chooseDokterKonsultasi: this.state.optDokter[indexDokter],
                            peserta_noTelp: row.NO_TELP,
                            peserta_email: row.EMAIL,
                            peserta_pekerjaan: row.PEKERJAAN,
                            peserta_riwayatKeluhanUtama: row.RIWAYAT_KELUHAN_UTAMA,
                            peserta_riwayatPenyakitKeluarga: row.RIWAYAT_PENYAKIT_KELUARGA,
                            peserta_riwayatPenyakitDahulu: row.RIWAYAT_PENYAKIT_DAHULU,
                            peserta_riwayatAlergiObat: row.RIWAYAT_ALERGI_OBAT,
                            tabkey: 1,
                            updateBtnV2: true,
                            _editFormActive: true,
                        })

                        if (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) {
                            this.setState({
                                editJanjiHasil: true
                            })
                        }


                    };


                    const _daftarUlang = (event) => {

                        this.setState({
                            returnDateRequestMode: true,
                            selectID_returnDateRequest: row.ID_REGISTRASI,
                            selectStatus_returnDateRequest: row.last_return_status,
                        })

                        this.daftarUlangConfirm(row);

                    };

                    const _cancel = (event) => {
                        this.cancelConfirm(row);

                    };


                    const _editRequest = (event) => {
                        console.log("happyhappy", row);

                        let indexKonsultasi = this.state.optKonsultasi.findIndex(function (item, i) {
                            return item.value == row.ID_KONSULTASI
                        });


                        let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                            return item.value === row.branch_code
                        });

                        let indexDokter = this.state.optDokter.findIndex(function (item, i) {
                            return item.value === row.DPJP
                        });

                        let indexDokterKonsultasi = [];


                        setTimeout(() => {
                            if (Cookies.get('biomedika-level') == 3) {
                                document.getElementById("notelp2").value = row.NO_TELP2;
                                document.getElementById("email2").value = row.EMAIL2;
                            }
                        }, 1000);

                        this.getDokterKonsultasi(row.ID_KONSULTASI)


                        this.setState({
                            modalForm: true,
                            peserta_idReg: row.ID_REGISTRASI,
                            peserta_namaPasien: row.NAMA_PASIEN,
                            peserta_NOMR: row.NOMR,
                            peserta_NIK: row.NIK,
                            peserta_NOREG: row.NOREG,
                            peserta_dateReg: moment(moment.utc(row.DATE_REGISTRASI)).local().format("YYYY-MM-DD"),
                            peserta_jenisKelamin: row.JENIS_KELAMIN,
                            peserta_tempatLahir: row.TEMPAT_LAHIR,
                            peserta_alamat: row.alamatPasien,
                            peserta_tglLayanan: moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD"),
                            peserta_jamLayanan: row.JAM_LAYANAN,
                            peserta_nasabah: row.NASABAH,
                            peserta_noBuktiLayanan: row.NO_BUKTI_LAYANAN,
                            peserta_dpjp: row.DPJP,
                            peserta_prioritas: row.PRIORITAS,
                            peserta_tanggalLahir: row.TANGGAL_LAHIR,
                            peserta_informasi: row.INFORMASI,
                            peserta_petugas: row.PETUGAS_INPUT,
                            peserta_petugasName: row.name,
                            dateRegHour: moment(moment.utc(row.DATE_REGISTRASI)).local().format("hh:mm:ss"),
                            peserta_dateReturn: moment(moment.utc(row.RETURN_DATE)).local().format("YYYY-MM-DD"),
                            chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                            chooseBranch: this.state.optBranch[indexBranch],
                            chooseDokterKonsultasi: this.state.optDokter[indexDokter],
                            peserta_noTelp: row.NO_TELP,
                            peserta_email: row.EMAIL,
                            peserta_pekerjaan: row.PEKERJAAN,
                            peserta_riwayatKeluhanUtama: row.RIWAYAT_KELUHAN_UTAMA,
                            peserta_riwayatPenyakitKeluarga: row.RIWAYAT_PENYAKIT_KELUARGA,
                            peserta_riwayatPenyakitDahulu: row.RIWAYAT_PENYAKIT_DAHULU,
                            peserta_riwayatAlergiObat: row.RIWAYAT_ALERGI_OBAT,
                            peserta_requestStatus: row.request_status,
                            peserta_requestBranch: row.request_branch,
                            tabkey: 1,
                            updateBtnV2: true,
                            _editFormActive: true,
                            peserta_antrianDokter: row.ANTRIAN_DOKTER,
                        })

                        if (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) {
                            this.setState({
                                editRequestStatus: true,
                                peserta_tglLayananBeforeReschedule: moment(moment.utc(row.TGL_LAYANAN)).local().format("YYYY-MM-DD"),
                            })
                        }

                    };

                    const _delete = (event) => {
                        // alert(row.id);
                        console.log("happyhappy", row);
                        this.deleteRowPatient(row.ID_REGISTRASI, row.NAMA_PASIEN);
                    };

                    const _generatedTicket = (event) => {
                        this.generateTicketConfirm(row);
                    };


                    const _print = (event) => {
                        console.log("happyhappy print", row);
                        this.setState({ _goPrint: true });
                        this.logPrint(row.NAMA_PASIEN, row.NOMR);

                        setTimeout(() => {
                            this.playInterval();
                            this.setState({
                                showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true
                            })
                        }, 1000);
                    };

                    const _payment = (event) => {
                        console.log("happyhappy pay", row);

                        // this.fetchDataDetail(row.ID_REGISTRASI)

                        let indexKonsultasi = this.state.optKonsultasi.findIndex(function (item, i) {
                            return item.value === row.ID_KONSULTASI
                        });

                        // let indexPembayaran = this.state.optPembayaran.findIndex(function (item, i) {
                        //     return item.value === row.METODE_PEMBAYARAN
                        // });

                        let _pembayaranKonsultasi = "";
                        let _pembayaranBio = "";
                        let _pembayaranTotal = "";
                        let _priceKonsultasi = this.state.optKonsultasi[indexKonsultasi];

                        if (row.PEMBAYARAN_KONSULTASI == 1) {
                            // _pembayaranKonsultasi = "FREE";
                            // _pembayaranBio = "Rp." + numberFormat((25 / 100) * _priceKonsultasi?.price).replace("Rp", "");
                            _pembayaranKonsultasi = "FREE";
                            _pembayaranBio = "FREE";
                            _pembayaranTotal = "Rp." + numberFormat(0).replace("Rp", "")
                        } else if (row.PEMBAYARAN_KONSULTASI == 0) {
                            _pembayaranKonsultasi = "Rp." + numberFormat(_priceKonsultasi?.price - ((25 / 100) * _priceKonsultasi?.price)).replace("Rp", "");
                            _pembayaranBio = "Rp." + numberFormat((25 / 100) * _priceKonsultasi?.price).replace("Rp", "");
                            _pembayaranTotal = "Rp." + numberFormat(_priceKonsultasi?.price).replace("Rp", "");
                        } else if (row.PEMBAYARAN_KONSULTASI == 2) {
                            // let _step1 = _priceKonsultasi?.price - ((25 / 100) * _priceKonsultasi?.price);
                            // _pembayaranKonsultasi = "Rp." + numberFormat(_step1 - ((row.PEMBAYARAN_DISKON / 100) * _step1)).replace("Rp", "");
                            let _step1 = _priceKonsultasi?.price - ((row.PEMBAYARAN_DISKON / 100) * _priceKonsultasi?.price);
                            _pembayaranKonsultasi = "Rp." + numberFormat(_step1 - ((25 / 100) * _step1)).replace("Rp", "");
                            let _step2 = _priceKonsultasi?.price - ((row.PEMBAYARAN_DISKON / 100) * _priceKonsultasi?.price);
                            _pembayaranBio = "Rp." + numberFormat((25 / 100) * _step2).replace("Rp", "");
                            _pembayaranTotal = "Rp." + numberFormat((_step1 - ((25 / 100) * _step1)) + ((25 / 100) * _step2)).replace("Rp", "");

                        } else if (row.PEMBAYARAN_KONSULTASI == 3) {
                            _pembayaranKonsultasi = "FREE";
                            _pembayaranBio = "FREE";
                            _pembayaranTotal = "Rp." + numberFormat(0).replace("Rp", "")
                        } else { }


                        this.setState({
                            peserta_pembayaranKonsultasiType: row.PEMBAYARAN_KONSULTASI,
                            peserta_pembayaranKonsultasi: _pembayaranKonsultasi,
                            peserta_pembayaranBio: _pembayaranBio,
                            peserta_pembayaranTotal: _pembayaranTotal,
                            peserta_pembayaranDiskon: row.PEMBAYARAN_DISKON,
                            peserta_alasanDiskon: row.ALASAN_DISKON,
                            peserta_tipePasien: row.TIPE_PASIEN,
                            // choosePembayaran: this.state.optPembayaran[indexPembayaran],
                            // peserta_tglPembayaran: moment(row.DATE_PEMBAYARAN, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD"),
                            // dateStatusPembayaranHour: moment(row.DATE_PEMBAYARAN, 'hh:mm:ss').format("hh:mm:ss"),
                            // peserta_statusPembayaran: row.STATUS,
                            chooseKonsultasi: this.state.optKonsultasi[indexKonsultasi],
                            // peserta_idPembayaran: row.ID_PEMBAYARAN,
                            // peserta_ketBiayaKonsul: row.KETERANGAN_BIAYA_KONSULTASI,
                            // peserta_statusSelesai: row.STATUS,
                            tabkey: 1,
                            _editFormActive: true,
                            updateBtnV2: true,
                            modalForm: false, modalPayment: true, ExistingRecord: true,
                        })
                    };

                    const _email = (event) => {
                        console.log("happyhappy", row);
                        // tolong buat parse nya pembayaran detail sekalian
                        // this.sendEmail(row);
                        this.fetchDataDetail(row.ID_REGISTRASI, row, "email");
                        this.setState({ _goPrint: true })
                        setTimeout(() => {
                            this.setState({
                                showModal: false, _goPrint: false, _delSwalPatient: false, _editFormActive: false, clr_child: true
                            })
                        }, 1000);
                    };

                    return (
                        <ul className="list-inline m-0 d-flex justify-content-center">

                            {
                                Cookies.get('biomedika-level') == 3 ?

                                    (
                                        <li className="list-inline-item"
                                        >
                                            <button
                                                className="btn btn-success btn-sm rounded-0"
                                                type="button"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Edit"
                                                onClick={_edit}
                                                style={{ backgroundImage: "url(" + _editPencil + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                            >
                                                {/* <i className="fa fa-edit" /> */}
                                            </button>
                                        </li>
                                    ) : null
                            }

                            {
                                (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) && this.state.peserta_filter?.value == "periksa_lab" && row.return_request != 2 && row.REG_STATUS == 'klinik' ?

                                    (
                                        <li className="list-inline-item"
                                        // style={{ cursor: moment(moment(moment.utc(row.TGL_LAYANAN).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true ? 'not-allowed' : null }}
                                        >
                                            <button
                                                // className={moment(moment(moment.utc(row.TGL_LAYANAN).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true ? "btn btn-light btn-sm rounded-0" : "btn btn-success btn-sm rounded-0"}
                                                className="btn btn-sm rounded-0"
                                                type="button"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Janji Hasil"
                                                onClick={_editJ}
                                                style={{ backgroundColor: '#bae1ff', backgroundImage: "url(" + _calendarJ + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                            // disabled={moment(moment(moment.utc(row.TGL_LAYANAN).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true ? true : false}
                                            >
                                                {/* <i className="fa fa-calendar" /> */}
                                            </button>
                                        </li>
                                    ) : null
                            }


                            {
                                (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) && this.state.peserta_filter?.value == "periksa_lab" && row.return_request != 2 && row.REG_STATUS == 'klinik' ?

                                    (
                                        <li className="list-inline-item"
                                            style={{ cursor: moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true || row.JANJI_HASIL == '0000-00-00' ? 'not-allowed' : null }}
                                        >
                                            <button
                                                className={"btn btn-success btn-sm rounded-0"}
                                                // className={moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true || row.JANJI_HASIL == '0000-00-00' ? "btn btn-light btn-sm rounded-0" : "btn btn-success btn-sm rounded-0"}
                                                type="button"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Return Date"
                                                onClick={_edit}
                                                // style={{ backgroundImage: moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true | row.JANJI_HASIL == '0000-00-00' ? "url(" + _calendar + ")" : "url(" + _calendar_w + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                                style={{ backgroundImage: "url(" + _calendar_w + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                            // disabled={moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true | row.JANJI_HASIL == '0000-00-00' ? true : false}
                                            >
                                                {/* <i className="fa fa-calendar" /> */}
                                            </button>
                                        </li>
                                    ) : null
                            }



                            <li className="list-inline-item"
                                // style={{ display: "none" }}
                                // style={{ display: row.request_status == "Sedang diproses!" ? null : "none" }}
                                style={{ display: localStorage.getItem("branch") == row.branch_code && row.request_branch != "" ? null : "none" }}
                            >
                                <button
                                    className="btn btn-success btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Request"
                                    onClick={_editRequest}
                                    style={{
                                        backgroundImage: "url(" + _rs + ")",
                                        backgroundSize: "cover",
                                        backgroundSize: '20px',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        width: "30px",
                                        height: "30px",
                                        marginRight: '7px'
                                    }}>
                                    {/* <i className="fa fa-check" /> */}
                                </button>

                            </li>


                            <li className="list-inline-item" style={{ display: Cookies.get('biomedika-level') != 3 ? 'none' : null }}>
                                <button
                                    className="btn btn-danger btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Delete"
                                    onClick={_delete}
                                    style={{ backgroundImage: "url(" + _trash + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-trash" /> */}
                                </button>
                            </li>

                            <li className="list-inline-item" style={{ display: row.STATUS != "" || row.request_status == "Ditolak!" || row.REG_STATUS == 'konsultasi' ? 'none' : null }}>
                                <button
                                    className="btn btn-danger btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Cancel"
                                    onClick={_cancel}
                                    style={{ backgroundImage: "url(" + _ban + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-ban" /> */}
                                </button>
                            </li>

                            <li className="list-inline-item" style={{ display: row.ANTRIAN_DOKTER != "" || row.request_status == "Ditolak!" || row.request_status == "Sedang diproses!" || row.return_request != 0 || row.last_return_status != "" ? 'none' : null }}>

                                {moment.utc(row.TGL_LAYANAN).local().format("YYYY-MM-DD") == moment().local().format("YYYY-MM-DD") ? (<button
                                    className="btn btn-success btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Generate Ticket"
                                    onClick={_generatedTicket}
                                    style={{ backgroundImage: "url(" + _gt + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-plane" /> */}
                                </button>) : null}

                            </li>

                            <li className="list-inline-item" style={{ display: row.examCount == 0 || row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" || row.REG_STATUS == 'konsultasi' ? 'none' : null }}>
                                <button
                                    className="btn btn-success btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Pembayaran"
                                    onClick={_payment}
                                    style={{ backgroundImage: "url(" + _credit + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                >
                                    {/* <i className="fa fa-credit-card" /> */}
                                </button>
                            </li>

                            {row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" ? null : (<><li className="list-inline-item" style={{ display: row.examCount == 0 || row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" || row.REG_STATUS == 'konsultasi' ? 'none' : null }}>
                                <div onClick={_print}>
                                    <ButtonPrint item={row} />
                                </div>
                            </li>

                                <li className="list-inline-item" style={{ display: row.examCount == 0 || row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" || row.REG_STATUS == 'konsultasi' ? 'none' : null }}>
                                    <div onClick={_print}>
                                        <ButtonPrintDefault item={row} />
                                    </div>
                                </li>


                                <li className="list-inline-item" style={{ display: row.examCount == 0 || row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" ? 'none' : null }}>
                                    <div onClick={_print}>
                                        <ButtonPrintResep item={row} />
                                    </div>
                                </li>


                                <li className="list-inline-item" style={{ display: row.examCount == 0 || row.STATUS == "" || row.STATUS == "Selesai Diperiksa Perawat" ? 'none' : null }}>
                                    <div onClick={_print}>
                                        <ButtonPrintSuratSakit item={row} />
                                    </div>
                                </li>
                            </>
                            )}



                            {/* <li className="list-inline-item" style={{ display: this.state.peserta_filter != "registrasi" ? 'none' : null }}>
                                <div onClick={_print}>
                                    <TextPost item={row} />
                                </div>

                            </li> */}


                            <li className="list-inline-item" style={{ display: this.state.peserta_filter?.value != "registrasi" || row.examCount > 0 || row.request_status == "Ditolak!" || row.ANTRIAN_DOKTER == "" ? 'none' : null }}>
                                <div onClick={_print}>
                                    <ButtonPrintTicket item={row} />
                                </div>
                            </li>

                            {/* <li className="list-inline-item" style={{ display: row.return_request == 2 ? null : 'none' }}>
                                <div onClick={_print}>
                                    <ButtonPrintTicket item={row} />
                                </div>
                            </li> */}


                            <li className="list-inline-item" style={{ display: row.return_request == 0 && row.last_return_status != "" ? null : 'none ' }}>
                                <button
                                    className="btn btn-success btn-sm rounded-0"
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Edit"
                                    style={{ width: '100px', fontSize: '12px' }}
                                    onClick={_daftarUlang}
                                >
                                    {/* <i className="fa fa-" /> */}
                                    Daftar Ulang
                                </button>
                            </li>

                            {/* <li className="list-inline-item" style={{ display: row.examCount == 0 ? 'none' : null }}>
                                <div onClick={_print}>
                                    <ReactWhatsapp
                                        className="btn btn-success btn-sm rounded-0" style={{ backgroundImage: "url(" + volumeUp + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Print"
                                        disabled={row.NO_TELP ? false : true}
                                        number={row.NO_TELP ? row.NO_TELP.replace(/\D/g, '').replace(/0/, '+62') : "000"}
                                        message="Hello World!!!"
                                    />
                                </div>
                            </li>

                            <li className="list-inline-item" style={{ display: row.examCount == 0 ? 'none' : null }}>
                                <div >
                                    <button
                                        className="btn btn-success btn-sm rounded-0"
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Print"
                                        disabled={row.EMAIL ? false : true}
                                        onClick={_email}
                                    >
                                        <i className="fa fa-envelope" />
                                    </button>
                                </div>
                            </li> */}

                            {/* 
                            {
                                (Cookies.get('biomedika-level') == 1 || Cookies.get('biomedika-level') == 4) && this.state.peserta_filter?.value != "registrasi" && row.return_request != 2 ?

                                    (
                                        <p style={{fontSize: 12}}>
                                            {moment(moment(moment.utc(row.TGL_LAYANAN).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true ? "return date telah expired" : "daftar segera!"}
                                        </p>
                                    ) : null
                            } */}


                        </ul>
                    );
                },
            },

            // {
            //     dataField: "ID_REGISTRASI",
            //     text: "No.",
            //     // formatter: this.imgFormatter,
            //     style: {
            //         fontWeight: 'normal',
            //         margin: '2px auto',
            //         fontSize: '12px',

            //     },
            //     headerAttrs: {
            //         hidden: false
            //     },
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', width: '20px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            {
                dataField: "NAMA_PASIEN",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "NAMA",
                sort: true,
                formatter: this.handleRowsClick,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NOMR",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },

                text: "NO. MR",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NOREG",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "NO. REGISTRASI",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            {
                dataField: "NAMA_KONSULTASI",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "POLI / KONSULTASI",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
            },
            // {
            //     dataField: "DATE_REGISTRASI",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "DATE REGISTRASI",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            //     formatter: (cell, row, rowIndex) => {
            //         if (row.DATE_REGISTRASI == '0000-00-00 00:00:00' || row.DATE_REGISTRASI == null) {
            //             return (
            //                 <>
            //                     0000-00-00 00:00:00
            //                 </>
            //             )
            //         } else {
            //             return (
            //                 <>
            //                     {moment(moment.utc(row.DATE_REGISTRASI)).local().format("DD-MM-YYYY hh:mm")}
            //                 </>
            //             )
            //         }

            //     },
            // },
            // {
            //   dataField: "ID_REGISTRASI",
            //   style: {
            //     fontSize: '12px',
            //     textAlign: 'center',
            //   },
            //   text: "ID REGISTRASI",
            //   sort: true,
            //   headerStyle: (colum, colIndex) => {
            //     return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', width: '60px', height: '10px', textAlign: 'center', color: "#fff" };
            //   },
            // },

            // {
            //     dataField: "PRIORITAS",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "PRIORITAS",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "NO_TELP",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "NO. TELP",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "EMAIL",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "EMAIL",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "TANGGAL_LAHIR",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "TTL",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            //     formatter: (cell, row, rowIndex) => {
            //         if (row.TANGGAL_LAHIR == '0000-00-00' || row.TANGGAL_LAHIR == null) {
            //             return (
            //                 <>
            //                     0000-00-00
            //                 </>
            //             )
            //         } else {
            //             return (
            //                 <>
            //                     {row.TEMPAT_LAHIR != "" ? row.TEMPAT_LAHIR + ", " + moment(moment.utc(row.TANGGAL_LAHIR)).local().format("DD-MM-YYYY") : moment(moment.utc(row.TANGGAL_LAHIR)).local().format("DD-MM-YYYY")}
            //                 </>
            //             )
            //         }

            //     },
            // },
            // {
            //     dataField: "TANGGAL_LAHIR",
            //     formatter: (cell, row, rowIndex, formatExtraData) => {
            //         // var from = row.TANGGAL_LAHIR.split("-");
            //         // var birthdateTimeStamp = new Date(from[2], from[1] - 1, from[0]);
            //         var birthdateTimeStamp = new Date(row.TANGGAL_LAHIR);
            //         var cur = new Date();
            //         var diff = cur - birthdateTimeStamp;
            //         // This is the difference in milliseconds
            //         var currentAge = Math.floor(diff / 31557600000);
            //         return currentAge;
            //     },
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '100px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "UMUR",
            //     sort: true,
            // },


            // {
            //     dataField: "JENIS_KELAMIN",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "JENIS KELAMIN",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            {
                dataField: "alamatPasien",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "ALAMAT",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    return (
                        <>
                            {row.alamatPasien.substring(0, 80) + '...'}
                        </>
                    )
                },
            },

            // status pembayaran

            {
                dataField: "alamatPasien",
                hidden: this.state.peserta_filter?.value != "periksa_lab" ? true : false,
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "STATUS RETURN DATE",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.periksaLabCount > 1) {
                        return (
                            <h5>
                                <Badge bg="success">
                                    Sudah Periksa Lab
                                </Badge>

                            </h5>
                        )
                    }
                    else if (row.JANJI_HASIL == '0000-00-00' || row.periksaLabCount <= 1) {
                        return (
                            <h5>
                                <Badge style={{ backgroundColor: '#ffb3ba', }}>
                                    Belum Periksa Lab
                                </Badge>

                            </h5>
                        )
                    } else if (moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == true) {
                        return (
                            <h5>
                                <Badge bg="danger">
                                    Expired
                                </Badge>

                            </h5>
                        )
                    } else if (moment(moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("YYYY-MM-DD")).isBefore(moment().local().format("YYYY-MM-DD")) == false) {
                        return (
                            <p style={{ fontSize: 18, fontWeight: 'bold' }}>
                                <Badge bg="success">
                                    Berlaku s/d {moment(moment.utc(row.JANJI_HASIL).add(5, 'days')).local().format("DD MMMM YYYY")}
                                </Badge>

                            </p>
                        )
                    }


                },
            },

            {
                dataField: "Status Pembayaran",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                text: "STATUS PEMBAYARAN",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return (
                            <h5>
                                <Badge style={{ backgroundColor: '#FFAE19' }}>
                                    FREE
                                </Badge>
                            </h5>
                        )
                    } else {
                        if (row.STATUS_PEMBAYARAN == "Lunas") {
                            return (
                                <h5>
                                    <Badge bg="success">
                                        {"Lunas"}
                                    </Badge>
                                </h5>
                            )
                        } else {
                            return (
                                <h5>
                                    <Badge bg="danger">
                                        {"Belum Dibayar"}
                                    </Badge>
                                </h5>
                            )
                        }
                    }




                },
            },

            {
                dataField: "NOMR",
                text: "STATUS REGISTRASI",
                style: (cell, row, rowIndex) => {
                    if (row.request_status == "Sedang diproses!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: "#FFA7A0"
                        };
                    } else if (row.request_status == "" || row.request_status == "Disetujui" || row.request_status == "Reschedule") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                        };
                    } else if (row.request_status == "Ditolak!") {
                        return {
                            fontSize: '12px',
                            textAlign: 'center',
                            backgroundColor: " #FFB6C1"
                        };
                    } else { }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
                },
                formatter: (cell, row, rowIndex) => {
                    if (row.REG_STATUS == 'konsultasi') {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="dark">
                                    Konsultasi
                                </Badge>
                            </h5>
                        )
                    } else {
                        return (
                            <h5 style={{ textAlign: 'center' }}>
                                <Badge bg="light" text="dark" style={{ border: '2px solid black', borderRadius: '6px' }}>
                                    Klinik
                                </Badge>
                            </h5>
                        )
                    }
                },
            },

            // {
            //     dataField: "NASABAH",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "NASABAH",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "NO_BUKTI_LAYANAN",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "NO. BUKTI LAYANAN",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "DPJP",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "NAMA DOKTER",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            //     formatter: (cell, row, rowIndex) => {
            //         return (
            //             <>
            //                 {this.state.optDokter.find(el => el.value == row.DPJP).label}
            //             </>
            //         )
            //     },
            // },
            // {
            //     dataField: "INFORMASI",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "INFORMASI",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "ANTRIAN",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "ANTRIAN",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "ANTRIAN_DOKTER",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "ANTRIAN DOKTER",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "name",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "PETUGAS_INPUT",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
            // {
            //     dataField: "branch_name",
            //     style: {
            //         fontSize: '12px',
            //         textAlign: 'center',
            //     },
            //     text: "CABANG",
            //     sort: true,
            //     headerStyle: (colum, colIndex) => {
            //         return { fontWeight: '400', fontSize: '12px', textTransform: 'capitalize', padding: '8px', margin: '0px', minWidth: '200px', height: '10px', textAlign: 'center', color: "#fff" };
            //     },
            // },
        ];


        const pageButtonRenderer = ({
            page,
            active,
            disable,
            title,
            onPageChange
        }) => {
            const handleClick = (e) => {
                e.preventDefault();
                onPageChange(page);
            };

            console.log("pageACTIVEX", title)
            if (title != "Pre page") {
                if (title != "First page")
                    if (active) {
                        return (
                            <li className="paginationSectionList">
                                <a href="#" className="paginationSectionLinkActive" onClick={handleClick} >{page}</a>
                            </li>
                        );
                    } else {

                        return (
                            <li className="paginationSectionList">
                                <a href="#" className="paginationSectionLink" onClick={handleClick} >{page}</a>
                            </li>
                        );

                    }

            }

        };




        const options = {
            pageButtonRenderer,
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: "First",
            prePageText: "Back",
            nextPageText: "Next",
            lastPageText: "Last",
            nextPageTitle: "First page",
            prePageTitle: "Pre page",
            firstPageTitle: "Next page",
            lastPageTitle: "Last page",
            withFirstAndLast: false,
            alwaysShowAllBtns: false,
            showTotal: true,
            totalSize: this.state.datas.length,
            // hidePageListOnlyOnePage:
        };

        const tableRowEvents = {
            onClick: (e, row, rowIndex) => {
                switch (e.detail) {
                    case 1:
                        console.log("click");
                        handleShow(row)
                        handleRowClick(rowIndex)
                        break;
                    case 2:
                        console.log("double click");
                        break;
                    case 3:
                        console.log("triple click");
                        break;
                }
            },
            onMouseEnter: (e, row, rowIndex) => {
                // console.log('onMouseEnter', e);
                // console.log('onMouseEnter', row);
                // console.log('onMouseEnter', rowIndex);
            },
        };

        const handleRowClick = (row) => {
            this.setState({ selectedRows: row });
        };

        const formattedAge = (age) => {
            var from = age.split("/");
            var birthdateTimeStamp = new Date(from[2], from[1] - 1, from[0]);
            var cur = new Date();
            var diff = cur - birthdateTimeStamp;
            // This is the difference in milliseconds
            var currentAge = Math.floor(diff / 31557600000);
            return currentAge + " " + "Tahun";
        }

        const handleShow = (data) => {
            // var id_company = localStorage.getItem("Company_ID");
            this.stopInterval();
            this.fetchDataDetail(data.ID_REGISTRASI, data);
            console.log("seluruh data", data)
            // this.fetchDataDetail(data)
        }


        const ModalDetail = ({ paginationProps, paginationTableProps }) => {
            // console.log('this.state.dataDetail', this.state.dataDetail)
            return (

                <div className="position-absolute" style={{ top: "50px", zIndex: 6, }} ref={this.modalRef} id="slide" >
                    {/* <div className="position-absolute" style={{ top: "102px", zIndex: 6, }} ref={this.modalRef} id="slide" ></div> */}

                    {/* <div className="shadow rounded zindex-fixed overflow-scroll mr-3 peopleSubColumn1" style={{ backgroundColor: '#EFEFEF' }}   > */}
                    <div className="shadow rounded zindex-fixed mr-3 peopleSubColumn1" style={{ backgroundColor: '#EFEFEF' }}   >
                        <button className="btnCloseTable" onClick={this.handleCloseModalDetail()}></button>


                        {/* <Tabs
                            defaultActiveKey="_S"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="_S" title="S" className="scroll_tab">
                                <div>
                                    <p style={{ margin: '20px' }}>{this.state.dataDetail[0].S}</p>
                                </div>
                            </Tab>
                            <Tab eventKey="_O" title="O" className="scroll_tab">
                                <div>
                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>KESADARAN</h1>
                                        <p>{this.state.dataDetail[0].O_KESADARAN}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>TEKANAN DARAH</h1>
                                        <p>{this.state.dataDetail[0].O_TEKANAN}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>PERNAPASAN</h1>
                                        <p>{this.state.dataDetail[0].O_PERNAPASAN}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>NADI</h1>
                                        <p>{this.state.dataDetail[0].O_NADI}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>BERAT</h1>
                                        <p>{this.state.dataDetail[0].O_BERAT}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>SUHU</h1>
                                        <p>{this.state.dataDetail[0].O_SUHU}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>TINGGI</h1>
                                        <p>{this.state.dataDetail[0].O_TINGGI}</p>
                                    </div>

                                    <div style={{ margin: '20px' }}>
                                        <h1 style={{ fontSize: '18px', fontWeight: 'bold' }}>CATATAN</h1>
                                        <p>{this.state.dataDetail[0].O_FREETEXT}</p>
                                    </div>
                                </div>

                            </Tab>
                            <Tab eventKey="_A" title="A" className="scroll_tab">
                                <div>
                                    <p style={{ margin: '20px' }}>{this.state.dataDetail[0].A}</p>
                                </div>
                            </Tab>
                            <Tab eventKey="_P" title="P" className="scroll_tab">
                                <div>
                                    <p style={{ margin: '20px' }}>{this.state.dataDetail[0].P}</p>
                                </div>
                            </Tab>
                        </Tabs> */}


                        <div className="scroll_div">
                            <table className="table">
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>Data Registrasi</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td style={{ width: '240px' }}>
                                            No. MR
                                        </td>
                                        <td>: {this.state.dataDetail.NOMR}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            No. Registrasi
                                        </td>
                                        <td>: {this.state.dataDetail.NOREG}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Tanggal Registrasi
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.DATE_REGISTRASI)).local().format("DD MMMM YYYY - hh:mm")}</td>

                                    </tr>

                                    <tr>
                                        <td>
                                            Tanggal Layanan
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.TGL_LAYANAN)).local().format("DD MMMM YYYY")}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Jam Layanan
                                        </td>
                                        <td>: {this.state.dataDetail.JAM_LAYANAN}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.JANJI_HASIL == "0000-00-00" ? "none" : null }}>
                                        <td>
                                            Tanggal Janji Hasil
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.JANJI_HASIL)).local().format("DD MMMM YYYY")}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.RETURN_DATE == "0000-00-00" ? "none" : null }}>
                                        <td>
                                            Tanggal Balik
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.RETURN_DATE)).local().format("DD MMMM YYYY")}</td>
                                    </tr>



                                    <tr>
                                        <td>
                                            Kontrol Ulang
                                        </td>
                                        <td>: {this.state.dataDetail.KONTROL_ULANG == 1 ? "Iya" : "Tidak"}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table">
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>Data Pasien</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '240px' }}>
                                            Nama
                                        </td>
                                        <td>: {this.state.dataDetail.NAMA_PASIEN}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            NIK
                                        </td>
                                        <td>: {this.state.dataDetail.NIK}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Jenis Kelamin
                                        </td>
                                        <td>: {this.state.dataDetail.JENIS_KELAMIN}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Tempat/Tanggal Lahir
                                        </td>
                                        <td>: {this.state.dataDetail.TEMPAT_LAHIR + ", " + moment(moment.utc(this.state.dataDetail.TANGGAL_LAHIR)).local().format("DD MMMM YYYY")}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Alamat
                                        </td>
                                        <td>: {this.state.dataDetail.alamatPasien}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            No. Telp
                                        </td>
                                        <td>: {this.state.dataDetail.NO_TELP}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.NO_TELP2 == "" ? 'none' : null }}>
                                        <td>
                                            No. Telp (Alternatif)
                                        </td>
                                        <td>: {this.state.dataDetail.NO_TELP2}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Email
                                        </td>
                                        <td>: {this.state.dataDetail.EMAIL}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.EMAIL2 == "" ? 'none' : null }}>
                                        <td>
                                            Email (Alternatif)
                                        </td>
                                        <td>: {this.state.dataDetail.EMAIL2}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Pekerjaan
                                        </td>
                                        <td>: {this.state.dataDetail.PEKERJAAN}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Keluhan Utama
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_KELUHAN_UTAMA}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Penyakit Keluarga
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_PENYAKIT_KELUARGA}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Penyakit Dahulu
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_PENYAKIT_DAHULU}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            Riwayat Alergi Obat
                                        </td>
                                        <td>: {this.state.dataDetail.RIWAYAT_ALERGI_OBAT}</td>
                                    </tr>




                                    {/* <tr>
                                        <td>
                                            Prioritas
                                        </td>
                                        <td>: {this.state.dataDetail.PRIORITAS}</td>
                                    </tr> */}
                                    {/* <tr>
                                        <td>
                                            NO. Bukti Layanan
                                        </td>
                                        <td>: {this.state.dataDetail.NO_BUKTI_LAYANAN}</td>
                                    </tr> */}



                                </tbody>
                            </table>

                            <table className="table">
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>Data Poli / Konsultasi</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr>
                                        <td style={{ width: '240px' }}>
                                            Konsultasi
                                        </td>
                                        <td>: {this.state.optKonsultasi.find(el => el.value == this.state.dataDetail.ID_KONSULTASI).label}</td>
                                    </tr>

                                    <tr>
                                        <td >
                                            Nama Dokter
                                        </td>
                                        <td>: {this.state.optDokter.find(el => el.value == this.state.dataDetail.DPJP).label}</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            No. Antrian
                                        </td>
                                        <td>: {this.state.dataDetail.ANTRIAN_DOKTER}</td>
                                    </tr>

                                    <tr style={{ display: this.state.dataDetail.INFORMASI == "" ? 'none' : null }}>
                                        <td>
                                            Informasi
                                        </td>
                                        <td>: {this.state.dataDetail.INFORMASI}</td>
                                    </tr>
                                    <tr style={{ display: this.state.dataDetail.STATUS == "" ? 'none' : null }}>
                                        <td>
                                            Status
                                        </td>
                                        <td>: {this.state.dataDetail.STATUS}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Admin
                                        </td>
                                        <td>: {this.state.dataDetail.name}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table" style={{ display: this.state.dataDetail.ID_PEMBAYARAN ? null : 'none' }}>
                                <thead style={{ position: 'relative' }}>
                                    <tr>
                                        <th style={{ padding: '10px' }} colSpan={2}>
                                            <p style={{ marginBottom: '0px', textAlign: 'center', fontSize: '12px' }}>DETAIL PEMBAYARAN</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {/* <tr>
                                        <td style={{ width: '240px' }}>
                                            Sistem Pembiayaan
                                        </td>
                                        <td>: {this.state.dataDetail.NASABAH}</td>
                                    </tr> */}

                                    <tr>
                                        <td>
                                            Metode Pembayaran
                                        </td>
                                        <td>: {this.state.dataDetail.METODE_PEMBAYARAN}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '240px' }}>
                                            Status Pembayaran
                                        </td>
                                        <td>: {this.state.dataDetail.STATUS}</td>
                                    </tr>
                                    <tr style={{ display: this.state.dataDetail.KETERANGAN_BIAYA_KONSULTASI == "" ? 'none' : null }}>
                                        <td>
                                            Keterangan
                                        </td>
                                        <td>: {this.state.dataDetail.KETERANGAN_BIAYA_KONSULTASI}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Tanggal Pembayaran
                                        </td>
                                        <td>: {moment(moment.utc(this.state.dataDetail.DATE_PEMBAYARAN)).local().format("DD MMMM YYYY - hh:mm")}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Total Pembayaran
                                        </td>
                                        <td>: Rp.{numberFormat(this.state.dataDetail.HARGA_KONSULTASI).replace("Rp", "")}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>



                    </div>




                </div>
            )
        }

        const MySearch = (props) => {
            // console.log(props, "propss")
            let input;
            const handleClick = (e) => {
                // alert("jah")
                // console.log(input, "input isis")
                // console.log(e.target.value, "value input")
                // console.log(this.state.searchValue, "search value from mysearch")
                props.onSearch(this.input.value);
                // this.setState({ searchWord: e.target.value })
                // console.log(input.value, "")
            };

            const handleFocus = (e) => {
                // alert("jah");
                this.stopInterval();
            };

            const handleOnBlur = (e) => {
                // alert("jah");
                this.playInterval();
            };

            const handleClear = (e) => {
                // console.log(input, "input isis")
                // console.log(e.target.value, "value input")
                // console.log(this.state.searchValue, "search value from mysearch")
                props.onSearch("");
                this.input.value = "";
            };

            return (
                <>
                    <InputGroup className="mb-3">
                        {/* <input
              className="form-control border-right-0 border"
              style={{ backgroundColor: "white", padding: 0 }}
              ref={(n) => (input = n)}
              type="text"
            />
            <button
              className="btn btn-tropical-rain-forest"
              onClick={handleClick}
            >
              Search
            </button> */}
                        {/* <input ref={(n) => (console.log(n, "n value"))} onChange={handleClick} type="text" className="search-query form-control" value={this.props.location.state ? this.props?.location?.state?.Patient_ID : ""} placeholder="   Search" /> */}


                        <div className="input-group" style={{ width: '100%' }}>
                            <input
                                ref={myinput => (this.input = myinput)}
                                onChange={handleClick}
                                onFocus={handleFocus}
                                onBlur={handleOnBlur}
                                type="text" style={{ borderRadius: '50px' }} className="search-query form-control" value={this.state.searchValue} placeholder="   Search" />
                            {/* <span className="input-group-btn">
                    <button type="button" disabled>
                      <span className="fa fa-search"></span>
                    </button>
                  </span> */}

                            <span className="clr_child" style={{ display: this.state.clr_child ? null : 'none' }} >
                                <button type="button" className="clr_img_btn" onClick={handleClear}>
                                    {/* <span className="fa fa-search"></span> */}
                                </button>
                            </span>
                        </div>



                    </InputGroup>
                </>
            );
        };

        const contentTableInbox = ({ paginationProps, paginationTableProps }) => {
            return (
                <div>
                    <ToolkitProvider keyField="id" columns={columns} data={this.state.datas} search={{
                        defaultSearch: this.state.searchValue ? this.state.searchValue : ''
                    }}>
                        {(toolkitprops) => (
                            <div>



                                <div className="row justify-content-end" >
                                    {/* <div className="col-6">
                                        <p>Hi</p>
                                    </div> */}


                                    <Col className="">
                                        <ButtonGroup>
                                            <button className="btn btn-primary btn-sm"
                                                disabled={this.state.datas.length == 0 ? true : false}
                                                // onClick={() => this.setState({ modalForm: true, modalPayment: false, ExistingRecord: false, tabkey: 1 })}
                                                onClick={() => this.openModalAddForm()}
                                            >
                                                <i className="fa fa-plus" /> Add Registrasi
                                            </button>

                                            {/* <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalForm: true, modalPayment: false, ExistingRecord: true, tabkey: 1 })}>
                                                <i className="fa fa-plus" /> Add Existing Record
                                            </button> */}

                                            {/* <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalForm: false, modalPayment: true, ExistingRecord: true, tabkey: 1 })}>
                                                <i className="fa fa-plus" /> test payment
                                            </button> */}

                                            {/* <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalForm: true, addPatientPeriode: true, tabkey: 2 })}>
                                                <i className="fa fa-plus" /> Add Period
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalAddResult: true })}>
                                                <i className="fa fa-plus" /> Add Result
                                            </button>
                                            <button className="btn btn-primary btn-sm" onClick={() => this.setState({ modalAddTemuan: true })}>
                                                <i className="fa fa-plus" /> Add Temuan
                                            </button> */}
                                            {/* <select
                                                name="peserta_filter"
                                                // className="form-control"
                                                onChange={this.changeSelectFilter}
                                                value={this.state.peserta_filter}
                                                style={{ fontSize: '12px' }}
                                            >
                                                <option value="registrasi">REGISTRASI</option>
                                                <option value="selesai">SELESAI</option>
                                                <option value="periksa_lab">PERIKSA LAB</option>

                                            </select> */}


                                            <Select
                                                className='title'
                                                value={this.state.peserta_filter}
                                                name="dept"
                                                options={[
                                                    {
                                                        label: "Registrasi",
                                                        value: "registrasi"
                                                    },
                                                    {
                                                        label: "Selesai",
                                                        value: "selesai"
                                                    },
                                                    {
                                                        label: "Periksa Lab",
                                                        value: "periksa_lab"
                                                    },
                                                ]}
                                                placeholder="Pilih Registrasi"
                                                onChange={this.changeSelectFilter}
                                                menuPosition={'fixed'}


                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                        color: "#000",
                                                        // backgroundColor: 'rgba(231,230,227,255)',
                                                        // borderRadius: '10px',
                                                        width: "180px",
                                                        fontSize: '12px',
                                                    }),
                                                    option: provided => ({
                                                        ...provided,
                                                        fontSize: '12px',
                                                        zIndex: 999,
                                                    }),
                                                    dropdownIndicator: styles => ({
                                                        ...styles,
                                                        color: '#000',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        minHeight: 1,
                                                    }),
                                                    indicatorSeparator: () => null,
                                                }}
                                            />

                                            <Select
                                                className='title'
                                                value={this.state.chooseBranchPatient}
                                                name="dept"
                                                options={this.state.optBranch}
                                                placeholder="Pilih Cabang"
                                                onChange={this.changeSelectBranch}
                                                menuPosition={'fixed'}


                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                        color: "#000",
                                                        // backgroundColor: 'rgba(231,230,227,255)',
                                                        // borderRadius: '10px',
                                                        width: "180px",
                                                        fontSize: '12px',
                                                    }),
                                                    option: provided => ({
                                                        ...provided,
                                                        fontSize: '12px',
                                                        zIndex: 999,
                                                    }),
                                                    dropdownIndicator: styles => ({
                                                        ...styles,
                                                        color: '#000',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        minHeight: 1,
                                                    }),
                                                    indicatorSeparator: () => null,
                                                }}
                                            />

                                        </ButtonGroup>




                                    </Col>


                                    <Col>
                                        <MySearch  {...toolkitprops.searchProps} />
                                    </Col>

                                </div>



                                <Row className="justify-content-end">




                                </Row>

                                <div className="peopleColumn" style={{ overflowY: this.state.datas.length == 0 ? null : 'scroll' }}>
                                    {this.state.showModal && !this.state._delSwalPatient && !this.state._editFormActive && !this.state._goPrint && <ModalDetail />}

                                    <BootstrapTable
                                        striped
                                        bordered={false}
                                        hover
                                        // selectRow={selectRow}
                                        {...toolkitprops.baseProps}
                                        {...paginationTableProps}
                                        rowEvents={tableRowEvents}
                                        // wrapperClasses="table-responsive"
                                        noDataIndication={emptyDataMessage}

                                    />
                                </div>


                                <div className="paginationSection">
                                    {paginationProps.page == 1 ? <button disabled="true" className="paginationSectionButtonPrev" onClick={this.handlePrevPage(paginationProps)}></button> : (<button className="paginationSectionButtonPrev" onClick={this.handlePrevPage(paginationProps)}></button>)}
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />

                                    {paginationProps.page != this.state._totalPage ? (
                                        <>
                                            <ul className="pagination react-bootstrap-table-page-btns-ul">
                                                <li className="paginationSectionList">
                                                    <a href="#" className="paginationSectionLink">...</a>
                                                </li>
                                            </ul>
                                            <ul className="pagination react-bootstrap-table-page-btns-ul">
                                                <li className="paginationSectionList">
                                                    <a onClick={this.handleLastPage(paginationProps)} href="#" className="paginationSectionLink">{this.state._totalPage}</a>
                                                </li>
                                            </ul></>) : null}

                                    {paginationProps.page == this.state._totalPage ? <button disabled="true" className="paginationSectionButtonNext" onClick={this.handleNextPage(paginationProps)}></button> : <button className="paginationSectionButtonNext" onClick={this.handleNextPage(paginationProps)}></button>}
                                </div>


                            </div>
                        )}
                    </ToolkitProvider>
                </div >
            );
        }

        const selectRow = {
            mode: "checkbox",
            style: { backgroundColor: "#c8e6c9" },
            selectColumnStyle: {
                width: 20,
            },
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) input.indeterminate = indeterminate;
                    }}
                    {...rest}
                />
            ),
            selectionRenderer: ({ mode, ...rest }) => (
                <input
                    // style={{width:20}}
                    type={mode}
                    {...rest}
                />
            ),
        };


        // back
        if (this.state.redirect === true && this.state.action === true) {
            return (<Redirect to={{
                pathname: this.state.pathname,
                state: {
                    id: this.state.idSelected,
                    prevPage: this.state.prevPage,
                    prevState: this.state.prevState,
                    goTo: this.state.goTo,
                }
            }} />)
        }

        return (
            <>

                <div id="clearOverlay" style={{ display: this.state.tableInbox == true ? "none" : "flex" }}>
                    <div className="w-100 d-flex justify-content-center align-items-center">
                        <div className="sk-chase">
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                            <div className="sk-chase-dot" />
                        </div>
                    </div>
                </div>


                <Modal
                    // style={{width:'100%'}}
                    show={this.state.modalForm}
                    onHide={this.handleCloseModalForm.bind(this)}
                    backdrop="static"
                    size={this.state.editDateReturn || this.state.editJanjiHasil ? "lg" : 'xl'}
                    dialogClassName={this.state.editDateReturn || this.state.editJanjiHasil ? "custom-modal-sm" : "custom-modal"}
                    keyboard
                    centered
                >
                    <Modal.Header closeButton>
                        {/* <Modal.Title>ADD REGISTRASI</Modal.Title> */}
                        <table >
                            <tbody>
                                <tr>
                                    <td> <p style={{ fontWeight: 'bold', margin: '0px' }}>ADD REGISTRASI</p></td>
                                </tr>
                                <tr>
                                    {
                                        localStorage.getItem("branch") ?
                                            (
                                                <td><span style={{ fontSize: 12 }}>{localStorage.getItem("name")} - {this.state.optBranch ? this.state.optBranch.find(el => el.value == localStorage.getItem("branch")).label : null}</span></td>
                                            ) :

                                            <></>
                                    }
                                </tr>
                            </tbody>
                        </table>



                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>
                                <Col md={12}>
                                    <Nav
                                        // variant="pills"
                                        variant="tabs"
                                    // defaultActiveKey="/home"
                                    // style={{ marginLeft: 8, marginRight: 8 }}
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey={1}
                                                onClick={() => this.handleSelect(1)}
                                            // style={{ display: this.state.addPatientPeriode ? 'none' : null }}
                                            >
                                                Data Pasien
                                            </Nav.Link>
                                        </Nav.Item>
                                        {/* <Nav.Item>
                                            <Nav.Link
                                                eventKey={2}
                                                onClick={() => this.handleSelect(2)}
                                            >
                                                Pasien Period
                                            </Nav.Link>
                                        </Nav.Item> */}
                                    </Nav>
                                </Col>
                                <Col>
                                    <Tab.Content style={{ marginTop: 20 }}>
                                        <Tab.Pane eventKey={1} >
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content" style={{ display: this.state.editDateReturn || this.state.editRequestStatus || this.state.editJanjiHasil ? 'none' : null }}>
                                                    <div className="row">
                                                        <div className="col-md-6">

                                                            <div className="form-group" style={{ display: 'none' }}>
                                                                <label className="form-label">Petugas</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_petugasInput"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.updateBtnV2 ? this.state.peserta_petugasName : localStorage.getItem("name")}
                                                                    onChange={this.onChange}
                                                                    readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group" style={{ display: 'none' }}>
                                                                <label className="form-label">Branch</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseBranch}
                                                                    isDisabled={true}
                                                                    name="dept"
                                                                    options={this.state.optBranch}
                                                                    placeholder="Pilih Konsultasi"
                                                                    onChange={this.changeSelectBranch}
                                                                    menuPosition={'fixed'}


                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            // backgroundColor: 'rgba(231,230,227,255)',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Nama Lengkap</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_namaPasien"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_namaPasien}
                                                                    onChange={this.onChange}
                                                                    placeholder="Nama Peserta"
                                                                />
                                                            </div>

                                                            {/* <div className="form-group"
                                                                // style={{ display: this.state.ExistingRecord ? null : 'none' }}
                                                                style={{ display: this.state.updateBtnV2 ? 'none' : null }}
                                                            >
                                                                <label className="form-label">No. MR</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseNOMR}
                                                                    isSearchable={true}
                                                                    name="dept"
                                                                    options={this.state.optNOMR}
                                                                    placeholder="Pilih Peserta"
                                                                    onChange={this.changeSelectNOMR}
                                                                    menuPosition={'fixed'}

                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            // backgroundColor: 'rgba(231,230,227,255)',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">No. MR</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_NOMR"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_NOMR}
                                                                    onChange={this.onChange}
                                                                    readOnly={this.state.updateBtnV2 ? true : null}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">NIK </label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_NIK"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_NIK}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">No. Telp</label>
                                                                <input
                                                                    type="tel"
                                                                    pattern="[0-9]*"
                                                                    name="peserta_noTelp"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_noTelp}
                                                                    onChange={this.onChange}
                                                                    placeholder="No telp"
                                                                />
                                                            </div>



                                                            <CollapseNoTelp />

                                                            <div className="form-group">
                                                                <label className="form-label">Email</label>
                                                                <input
                                                                    type="email"
                                                                    name="peserta_email"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_email}
                                                                    onChange={this.onChange}
                                                                    placeholder="Email"
                                                                />
                                                            </div>



                                                            <CollapseEmail />




                                                            {/* <div className="form-group">
                                                                <label className="form-label">NOMR</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_NOMR"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_NOMR}
                                                                    onChange={this.onChange}
                                                                    readOnly={this.state.updateBtnV2 ? true : null}
                                                                />
                                                            </div> */}
                                                            {/* <div className="form-group">
                                                                <label className="form-label">NOREG</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_NOREG"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_NOREG}
                                                                    onChange={this.onChange}
                                                                    readOnly
                                                                />
                                                            </div> */}
                                                            {/* <div className="form-group">
                                                                <label className="form-label">Date REG</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_dateReg"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    min={this.state.minDate}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_dateReg)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}
                                                            <div className="form-group">
                                                                <label className="form-label">Jenis Kelamin</label>
                                                                <select
                                                                    name="peserta_jenisKelamin"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_jenisKelamin}
                                                                >
                                                                    <option value="Laki-Laki">Laki - Laki</option>
                                                                    <option value="Perempuan">Perempuan</option>
                                                                </select>
                                                            </div>
                                                            <div className="form-group">
                                                                <label className="form-label">Tempat Lahir</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_tempatLahir"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_tempatLahir}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Tanggal Lahir</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_tanggalLahir"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_tanggalLahir)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Alamat</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_alamat"
                                                                    value={this.state.peserta_alamat}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '124px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Pekerjaan</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_pekerjaan"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_pekerjaan}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>




                                                        </div>
                                                        <div className="col-md-6">

                                                            {/* <div className="form-group">
                                                                <label className="form-label">NO. Bukti Layanan</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_noBuktiLayanan"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_noBuktiLayanan}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Prioritas</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_prioritas"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_prioritas}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Keluhan Utama</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatKeluhanUtama"
                                                                    value={this.state.peserta_riwayatKeluhanUtama}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Penyakit Keluarga</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatPenyakitKeluarga"
                                                                    value={this.state.peserta_riwayatPenyakitKeluarga}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Penyakit Dahulu</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatPenyakitDahulu"
                                                                    value={this.state.peserta_riwayatPenyakitDahulu}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Riwayat Alergi Obat</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="peserta_riwayatAlergiObat"
                                                                    value={this.state.peserta_riwayatAlergiObat}
                                                                    onChange={this.onChange}
                                                                    style={{ height: '60px' }}
                                                                />
                                                            </div>




                                                            <div className="form-group" style={{ display: 'none' }}>
                                                                <label className="form-label">Sistem Pembiayaan</label>
                                                                <select
                                                                    name="peserta_nasabah"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_nasabah}
                                                                >
                                                                    <option value="Asuransi" disabled>Asuransi</option>
                                                                    <option value="BPJS" disabled>BPJS</option>
                                                                    <option value="Pasien Umum">Pasien Umum</option>
                                                                </select>

                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">Konsultasi</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseKonsultasi}
                                                                    isSearchable={true}
                                                                    name="dept"
                                                                    options={this.state.optKonsultasi}
                                                                    placeholder="Pilih Konsultasi"
                                                                    onChange={this.changeSelectKonsultasi}
                                                                    menuPosition={'fixed'}
                                                                    isDisabled={this.state.updateBtnV2 ? true : false}

                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            backgroundColor: 'white',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">Nama Dokter</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseDokterKonsultasi}
                                                                    isSearchable={true}
                                                                    name="dept"
                                                                    options={this.state.optDokterKonsultasi}
                                                                    placeholder="Pilih Dokter"
                                                                    onChange={this.changeSelectDokter}
                                                                    menuPosition={'fixed'}
                                                                    // isDisabled={true}

                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            // backgroundColor: 'rgba(231,230,227,255)',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">Tanggal Layanan</label>
                                                                {/* <input
                                                                    type="date"
                                                                    name="peserta_tglLayanan"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    min={this.state.minDate}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_tglLayanan)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                /> */}

                                                                <div style={{ textAlign: 'center' }}>
                                                                    <DayPicker

                                                                        selectedDays={this.state.selectedDay}
                                                                        onDayClick={this.handleDayClick}
                                                                        localeUtils={MomentLocaleUtils}
                                                                        locale={'id'}
                                                                        fromMonth={new Date(moment().year(), 0)}
                                                                        toMonth={new Date(moment().year(), 11)}
                                                                        disabledDays={
                                                                            // [
                                                                            //     { daysOfWeek: [0] },
                                                                            //     { before: new Date() },
                                                                            //     this.state.disabledDays
                                                                            // ]

                                                                            this.state.disabledDays

                                                                        }


                                                                    // selectedDays={[
                                                                    //     new Date(2024, 0, 11),
                                                                    //     new Date(2024, 0, 23),
                                                                    // ]}

                                                                    // initialMonth={new Date(2024, 0)}

                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <div style={{ textAlign: 'center' }}>
                                                                    <p>Tanggal Dipilih : <span style={{ fontWeight: '600' }}>{this.state.selectedDay ? moment(this.state.selectedDay).format("DD MMMM YYYY") : ""}</span></p>
                                                                </div>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Waktu Pendaftaran</label>
                                                                <Flex vertical gap="middle">
                                                                    <Radio.Group
                                                                        onChange={onChangeJamSelect}
                                                                        // defaultValue="a"
                                                                        buttonStyle="solid"
                                                                    >

                                                                        {this.state.opsiJam.map((item) => (
                                                                            <Radio.Button value={item.title} disabled={item.disabled}>{item.title}</Radio.Button>
                                                                        ))}

                                                                    </Radio.Group>
                                                                    {/* <div style={{ width: '100%', padding: '10px' }}>
                                                                    <Row>
                                                                        {this.state.opsiJam.map((item) => (
                                                                            <Col span={8}>
                                                                                <Checkbox
                                                                                    key={item.id}
                                                                                    checked={item.checked}
                                                                                    onChange={() => this.onChangeJam(item)}
                                                                                >
                                                                                    {item.title}
                                                                                </Checkbox>

                                                                            </Col>
                                                                        ))}

                                                                    </Row>
                                                                </div> */}
                                                                </Flex>
                                                            </div>


                                                            <div className="form-group">
                                                                <label className="form-label">Catatan Pasien</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_informasi"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_informasi}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group" style={{ display: this.state.updateBtnV2 ? null : 'none' }}>
                                                                <label className="form-label">Tanggal Balik</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_dateReturn"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    min={this.state.minDate}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_dateReturn)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>


                                                            <div className="form-group" style={{ display: this.state.updateBtnV2 ? null : 'none' }}>
                                                                <label className="form-label">Status Request</label>
                                                                <select
                                                                    name="peserta_requestStatus"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_requestStatus}
                                                                >
                                                                    <option value="Sedang diproses!"> -- Pilih Status --</option>
                                                                    <option value="Disetujui">Disetujui</option>
                                                                    <option value="Ditolak!">Batal</option>
                                                                </select>
                                                            </div>

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Antrian</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_antrian"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_antrian}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}

                                                            {/* <div className="form-group">
                                                                <label className="form-label">Petugas</label>
                                                                <input
                                                                    type="number"
                                                                    name="peserta_petugasInput"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_petugasInput}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}


                                                            {/* <div className="form-group">
                                                                <label className="form-label">Jenis Konsultasi</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseKonsultasi}
                                                                    isSearchable={true}
                                                                    name="dept"
                                                                    options={this.state.optKonsultasi}
                                                                    placeholder="Pilih Konsultasi"
                                                                    onChange={this.changeSelectKonsultasi}
                                                                    menuPosition={'fixed'}

                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            // backgroundColor: 'rgba(231,230,227,255)',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Harga Konsultasi</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_petugasInput"
                                                                    className="form-control"
                                                                    required
                                                                    value={"Rp." + numberFormat(this.state.chooseKonsultasi?.price).replace("Rp", "")}
                                                                    onChange={this.onChange}
                                                                    readOnly={true}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Metode Pembayaran</label>
                                                                <Select name="options" options={this.state.optPembayaran} value={this.state.choosePembayaran} onChange={this.changeSelectPembayaran} />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Tanggal Pembayaran</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_tglPembayaran"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_tglPembayaran)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Status Pembayaran</label>
                                                                <select
                                                                    name="peserta_statusPembayaran"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_statusPembayaran}
                                                                >
                                                                    <option value="BELUM LUNAS">BELUM LUNAS</option>
                                                                    <option value="LUNAS">LUNAS</option>

                                                                </select>
                                                            </div>

                                                            <div className="form-group">
                                                                <label className="form-label">Keterangan Biaya Konsultasi</label>
                                                                <input
                                                                    type="text"
                                                                    name="peserta_ketBiayaKonsul"
                                                                    className="form-control"
                                                                    required
                                                                    value={this.state.peserta_ketBiayaKonsul}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}


                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-content" style={{ display: this.state.editDateReturn ? null : 'none' }}>
                                                    <div className="row">

                                                        {/* <div className="form-group">
                                                            <label className="form-label">Konsultasi</label>
                                                            <Select
                                                                className='title'
                                                                value={this.state.chooseKonsultasi}
                                                                isSearchable={true}
                                                                name="dept"
                                                                options={this.state.optKonsultasi}
                                                                placeholder="Pilih Konsultasi"
                                                                onChange={this.changeSelectKonsultasi}
                                                                menuPosition={'fixed'}
                                                                isDisabled={this.state.updateBtnV2 ? true : false}

                                                                styles={{
                                                                    menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                        color: "#000",
                                                                        backgroundColor: 'white',
                                                                        borderRadius: '10px',
                                                                        // width: "140px",
                                                                        fontSize: '12px',
                                                                    }),
                                                                    option: provided => ({
                                                                        ...provided,
                                                                        fontSize: '12px',
                                                                        zIndex: 999,
                                                                    }),
                                                                    dropdownIndicator: styles => ({
                                                                        ...styles,
                                                                        color: '#000',
                                                                    }),
                                                                    indicatorsContainer: (base) => ({
                                                                        ...base,
                                                                        minHeight: 1,
                                                                    }),
                                                                    indicatorSeparator: () => null,
                                                                }}
                                                            />
                                                        </div> */}


                                                        <div className="form-group">
                                                            <label className="form-label">Nama Dokter</label>
                                                            <Select
                                                                className='title'
                                                                value={this.state.chooseDokterKonsultasi}
                                                                isSearchable={true}
                                                                name="dept"
                                                                options={this.state.optDokterKonsultasi}
                                                                placeholder="Pilih Dokter"
                                                                onChange={this.changeSelectDokter}
                                                                menuPosition={'fixed'}
                                                                // isDisabled={true}

                                                                styles={{
                                                                    menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                    control: (baseStyles, state) => ({
                                                                        ...baseStyles,
                                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                        color: "#000",
                                                                        // backgroundColor: 'rgba(231,230,227,255)',
                                                                        borderRadius: '10px',
                                                                        // width: "140px",
                                                                        fontSize: '12px',
                                                                    }),
                                                                    option: provided => ({
                                                                        ...provided,
                                                                        fontSize: '12px',
                                                                        zIndex: 999,
                                                                    }),
                                                                    dropdownIndicator: styles => ({
                                                                        ...styles,
                                                                        color: '#000',
                                                                    }),
                                                                    indicatorsContainer: (base) => ({
                                                                        ...base,
                                                                        minHeight: 1,
                                                                    }),
                                                                    indicatorSeparator: () => null,
                                                                }}
                                                            />
                                                        </div>


                                                        <div className="form-group">
                                                            <label className="form-label">Tanggal Layanan</label>
                                                            {/* <input
                                                                    type="date"
                                                                    name="peserta_tglLayanan"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    min={this.state.minDate}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_tglLayanan)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                /> */}

                                                            <div style={{ textAlign: 'center' }}>
                                                                <DayPicker

                                                                    selectedDays={this.state.peserta_dateReturn}
                                                                    onDayClick={this.handleDayClickReturn}
                                                                    localeUtils={MomentLocaleUtils}
                                                                    locale={'id'}
                                                                    fromMonth={new Date(moment().year(), 0)}
                                                                    toMonth={new Date(moment().year(), 11)}
                                                                    disabledDays={
                                                                        // [
                                                                        //     { daysOfWeek: [0] },
                                                                        //     { before: new Date() },
                                                                        //     this.state.disabledDays
                                                                        // ]

                                                                        this.state.disabledDays

                                                                    }


                                                                // selectedDays={[
                                                                //     new Date(2024, 0, 11),
                                                                //     new Date(2024, 0, 23),
                                                                // ]}

                                                                // initialMonth={new Date(2024, 0)}

                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <div style={{ textAlign: 'center' }}>
                                                                <p>Tanggal Dipilih : <span style={{ fontWeight: '600' }}>{this.state.peserta_dateReturn ? moment(this.state.peserta_dateReturn).format("DD MMMM YYYY") : ""}</span></p>
                                                            </div>
                                                        </div>

                                                        {/* <div className="col-md-12">
                                                            <div className="form-group" style={{ display: this.state.updateBtnV2 ? null : 'none' }}>
                                                                <label className="form-label">Tanggal Balik</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_dateReturn"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_dateReturn)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>

                                                        </div> */}
                                                    </div>
                                                </div>

                                                <div className="form-content" style={{ display: this.state.editRequestStatus ? null : 'none' }}>
                                                    <div className="row">

                                                        <div className="col-md-12">

                                                            <div className="form-group">
                                                                <label className="form-label">Status Request</label>
                                                                <select
                                                                    name="peserta_requestStatus"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_requestStatus}
                                                                >
                                                                    <option value="Sedang diproses!"> -- Pilih Status --</option>
                                                                    <option value="Disetujui">Setuju</option>
                                                                    <option value="Ditolak!">Batal</option>
                                                                    <option value="Reschedule">Reschedule</option>
                                                                </select>
                                                            </div>

                                                            {/* 
                                                            <div className="form-group" style={{ display: this.state.peserta_requestStatus == "Reschedule" ? null : 'none' }}>
                                                                <label className="form-label">Tanggal Reschedule</label>
                                                                <input
                                                                    type="date"
                                                                    name="peserta_tglLayanan"
                                                                    defaultValue={new Date().toISOString().slice(0, 10)}
                                                                    min={this.state.minDate}
                                                                    className="form-control"
                                                                    value={moment(new Date(this.state.peserta_tglLayanan)).format("YYYY-MM-DD")}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div> */}


                                                            <div className="form-group" style={{ display: this.state.peserta_requestStatus == "Reschedule" ? null : 'none' }}>
                                                                <label className="form-label">Nama Dokter</label>
                                                                <Select
                                                                    className='title'
                                                                    value={this.state.chooseDokterKonsultasi}
                                                                    isSearchable={true}
                                                                    name="dept"
                                                                    options={this.state.optDokterKonsultasi}
                                                                    placeholder="Pilih Dokter"
                                                                    onChange={this.changeSelectDokter}
                                                                    menuPosition={'fixed'}
                                                                    // isDisabled={true}


                                                                    styles={{
                                                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: (baseStyles, state) => ({
                                                                            ...baseStyles,
                                                                            borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                            color: "#000",
                                                                            // backgroundColor: 'rgba(231,230,227,255)',
                                                                            borderRadius: '10px',
                                                                            // width: "140px",
                                                                            fontSize: '12px',
                                                                        }),
                                                                        option: provided => ({
                                                                            ...provided,
                                                                            fontSize: '12px',
                                                                            zIndex: 999,
                                                                        }),
                                                                        dropdownIndicator: styles => ({
                                                                            ...styles,
                                                                            color: '#000',
                                                                        }),
                                                                        indicatorsContainer: (base) => ({
                                                                            ...base,
                                                                            minHeight: 1,
                                                                        }),
                                                                        indicatorSeparator: () => null,
                                                                    }}
                                                                />
                                                            </div>


                                                            <div className="form-group" style={{ display: this.state.peserta_requestStatus == "Reschedule" ? null : 'none' }}>
                                                                <label className="form-label">Tanggal Layanan</label>

                                                                <div style={{ textAlign: 'center' }}>
                                                                    <DayPicker

                                                                        selectedDays={this.state.peserta_tglLayanan}
                                                                        onDayClick={this.handleDayClickReschedule}
                                                                        localeUtils={MomentLocaleUtils}
                                                                        locale={'id'}
                                                                        fromMonth={new Date(moment().year(), 0)}
                                                                        toMonth={new Date(moment().year(), 11)}
                                                                        disabledDays={
                                                                            // [
                                                                            //     { daysOfWeek: [0] },
                                                                            //     { before: new Date() },
                                                                            //     this.state.disabledDays
                                                                            // ]

                                                                            this.state.disabledDays

                                                                        }


                                                                    // selectedDays={[
                                                                    //     new Date(2024, 0, 11),
                                                                    //     new Date(2024, 0, 23),
                                                                    // ]}

                                                                    // initialMonth={new Date(2024, 0)}

                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="form-group" style={{ display: this.state.peserta_requestStatus == "Reschedule" ? null : 'none' }}>
                                                                <div style={{ textAlign: 'center' }}>
                                                                    <p>Tanggal Dipilih : <span style={{ fontWeight: '600' }}>{this.state.peserta_tglLayanan ? moment(this.state.peserta_tglLayanan).format("DD MMMM YYYY") : ""}</span></p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-content" style={{ display: this.state.editJanjiHasil ? null : 'none' }}>
                                                    <div className="row">
                                                        <div className="form-group">
                                                            <label className="form-label">Tanggal Janji Hasil</label>
                                                            <input
                                                                type="date"
                                                                name="peserta_janjiHasil"
                                                                defaultValue={new Date().toISOString().slice(0, 10)}
                                                                min={this.state.minDate}
                                                                className="form-control"
                                                                value={moment(new Date(this.state.peserta_janjiHasil)).format("YYYY-MM-DD")}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </Tab.Pane>
                                        {/* <Tab.Pane eventKey={2}>

                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">
                                                        <div className="col-md-6">

                                                        </div>
                                                        <div className="col-md-6">

                                                        </div>
                                                    </div>
                                                </div>

                                            </form>



                                        </Tab.Pane> */}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>
                                {/* <Col
                                    style={{
                                        display: this.state.tabkey == 1 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="lanjut"
                                        className="btn btn-info waves-effect"
                                        onClick={() => this.handleSelect(2)}
                                    >
                                        {" "}
                                        next
                                    </a>
                                </Col> */}
                                <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.save_v2.bind(this)}
                                        style={{ display: this.state.updateBtnV2 ? 'none' : null }}
                                    >
                                        {" "}
                                        Save
                                    </a>


                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v2.bind(this)}
                                        style={{ display: this.state.updateBtnV2 && !this.state.editDateReturn && !this.state.editJanjiHasil ? null : 'none' }}
                                    >
                                        {" "}
                                        Update
                                    </a>

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v5.bind(this)}
                                        style={{ display: this.state.updateBtnV2 && this.state.editDateReturn && !this.state.editJanjiHasil ? null : 'none' }}
                                    >
                                        {" "}
                                        Update
                                    </a>

                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v8.bind(this)}
                                        style={{ display: this.state.updateBtnV2 && this.state.editJanjiHasil ? null : 'none' }}
                                    >
                                        {" "}
                                        Update
                                    </a>
                                </Col>
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalForm.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>

                        {/* <button
              type="button"
              className="close"
              onClick={this.handleCloseModalForm.bind(this)}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button> */}
                    </Modal.Footer>
                </Modal >




                <Modal
                    show={this.state.modalPayment}
                    onHide={this.handleCloseModalPayment.bind(this)}
                    backdrop="static"
                    size="lg"
                    dialogClassName="custom-modal-sm"
                    keyboard
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ADD PEMBAYARAN</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>

                                <Col>
                                    <form action="#" encType="multipart/form-data" id="form_add">
                                        <div className="form-content">
                                            <div className="row">

                                                <div className="col-md-12">

                                                    <div className="form-group">
                                                        <label className="form-label">Telah Diterima Dari</label>
                                                        <input
                                                            type="text"
                                                            name="peserta_receivedFrom"
                                                            className="form-control"
                                                            required
                                                            value={this.state.peserta_receivedFrom}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Jenis Konsultasi</label>
                                                        <Select
                                                            className='title'
                                                            value={this.state.chooseKonsultasi}
                                                            isSearchable={true}
                                                            name="dept"
                                                            options={this.state.optKonsultasi}
                                                            placeholder="Pilih Konsultasi"
                                                            onChange={this.changeSelectKonsultasi}
                                                            menuPosition={'fixed'}
                                                            isDisabled={true}

                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                    color: "#000",
                                                                    // backgroundColor: 'rgba(231,230,227,255)',
                                                                    borderRadius: '10px',
                                                                    // width: "140px",
                                                                    fontSize: '12px',
                                                                }),
                                                                option: provided => ({
                                                                    ...provided,
                                                                    fontSize: '12px',
                                                                    zIndex: 999,
                                                                }),
                                                                dropdownIndicator: styles => ({
                                                                    ...styles,
                                                                    color: '#000',
                                                                }),
                                                                indicatorsContainer: (base) => ({
                                                                    ...base,
                                                                    minHeight: 1,
                                                                }),
                                                                indicatorSeparator: () => null,
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="form-group" style={{ display: 'none' }}>
                                                        <label className="form-label">Biaya Konsultasi</label>
                                                        <input
                                                            type="text"
                                                            name="peserta_petugasInput"
                                                            className="form-control"
                                                            required
                                                            // value={this.state.peserta_pembayaranKonsultasi == 1 ? "Biaya Ditanggung Dokter (FREE)" : "Rp." + numberFormat(this.state.chooseKonsultasi?.price - ((25 / 100) * this.state.chooseKonsultasi?.price)).replace("Rp", "")}
                                                            value={this.state.peserta_pembayaranKonsultasi}
                                                            onChange={this.onChange}

                                                            readOnly={true}
                                                        />
                                                    </div>

                                                    <div className="form-group" style={{ display: 'none' }}>
                                                        <label className="form-label">Biaya Administrasi</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            required
                                                            value={this.state.peserta_pembayaranBio}
                                                            readOnly={true}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Total Pembayaran</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            required
                                                            value={this.state.peserta_pembayaranTotal}
                                                            readOnly={true}
                                                        />
                                                    </div>

                                                    {this.state.peserta_pembayaranKonsultasiType == 1 ? (
                                                        <div className="form-group">
                                                            <label className="form-label">Tipe Pasien</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                value={"Non Karyawan"}
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                    ) : null}

                                                    {this.state.peserta_pembayaranKonsultasiType == 3 ? (
                                                        <div className="form-group">
                                                            <label className="form-label">Tipe Pasien</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                value={"Karyawan"}
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                    ) : null}

                                                    {this.state.peserta_pembayaranKonsultasiType == 2 ? (
                                                        <div className="form-group">
                                                            <label className="form-label">Diskon</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                value={this.state.peserta_pembayaranDiskon + "%"}
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                    ) : null}

                                                    {this.state.peserta_pembayaranKonsultasiType == 2 ? (
                                                        <div className="form-group">
                                                            <label className="form-label">Alasan Diskon</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                value={this.state.peserta_alasanDiskon}
                                                                readOnly={true}
                                                            />
                                                        </div>

                                                    ) : null}


                                                    <div className="form-group">
                                                        <label className="form-label">Metode Pembayaran</label>
                                                        <Select
                                                            name="options"
                                                            options={this.state.optPembayaran}
                                                            value={this.state.choosePembayaran}
                                                            onChange={this.changeSelectPembayaran}
                                                            placeholder="Pilih Pembayaran"

                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 9999 }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                                    color: "#000",
                                                                    backgroundColor: 'white',
                                                                    borderRadius: '10px',
                                                                    // width: "140px",
                                                                    fontSize: '14px',
                                                                }),
                                                                option: provided => ({
                                                                    ...provided,
                                                                    fontSize: '14px',
                                                                    zIndex: 999,
                                                                }),
                                                                dropdownIndicator: styles => ({
                                                                    ...styles,
                                                                    color: '#000',
                                                                }),
                                                                indicatorsContainer: (base) => ({
                                                                    ...base,
                                                                    minHeight: 1,
                                                                }),
                                                                indicatorSeparator: () => null,
                                                            }}

                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Tanggal Pembayaran</label>
                                                        <input
                                                            type="date"
                                                            name="peserta_tglPembayaran"
                                                            defaultValue={new Date().toISOString().slice(0, 10)}
                                                            className="form-control"
                                                            value={moment(new Date(this.state.peserta_tglPembayaran)).format("YYYY-MM-DD")}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Status Pembayaran</label>
                                                        <select
                                                            name="peserta_statusPembayaran"
                                                            className="form-control"
                                                            onChange={this.onChange}
                                                            value={this.state.peserta_statusPembayaran}
                                                        >
                                                            <option value="Belum Lunas">Belum Lunas</option>
                                                            <option value="Lunas">Lunas</option>

                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-label">Catatan</label>
                                                        <input
                                                            type="text"
                                                            name="peserta_ketBiayaKonsul"
                                                            className="form-control"
                                                            required
                                                            value={this.state.peserta_ketBiayaKonsul}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>

                                                    {/* <div className="form-group">
                                                                <label className="form-label">Status</label>
                                                                <select
                                                                    name="peserta_statusSelesai"
                                                                    className="form-control"
                                                                    onChange={this.onChange}
                                                                    value={this.state.peserta_statusSelesai}
                                                                >
                                                                    <option value="SELESAI">SELESAI</option>
                                                                    <option value="PERIKSA LAB">LANJUT PERIKSA LAB</option>

                                                                </select>
                                                            </div> */}


                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>

                                <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v3.bind(this)}
                                    >
                                        {" "}
                                        {this.state.updateBtnV3 ? "Update" : "Save"}
                                    </a>
                                </Col>
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalPayment.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>

                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.modalPemeriksaan}
                    onHide={this.handleCloseModalPemeriksaan.bind(this)}
                    backdrop="static"
                    size="lg"
                    dialogClassName="custom-modal-sm"
                    keyboard
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ADD PEMERIKSAAN</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tab.Container id="left-tabs-example" activeKey={this.state.tabkey}>
                            <Row>
                                <Col md={12}>
                                    <Nav
                                        // variant="pills"
                                        variant="tabs"
                                    // defaultActiveKey="/home"
                                    // style={{ marginLeft: 8, marginRight: 8 }}
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                eventKey={1}
                                                onClick={() => this.handleSelect(1)}
                                            // style={{ display: this.state.addPatientPeriode ? 'none' : null }}
                                            >
                                                Data Pasien
                                            </Nav.Link>
                                        </Nav.Item>
                                        {/* <Nav.Item>
                                            <Nav.Link
                                                eventKey={2}
                                                onClick={() => this.handleSelect(2)}
                                            >
                                                Pasien Period
                                            </Nav.Link>
                                        </Nav.Item> */}
                                    </Nav>
                                </Col>
                                <Col>
                                    <Tab.Content style={{ marginTop: 20 }}>
                                        <Tab.Pane eventKey={1} >
                                            <form action="#" encType="multipart/form-data" id="form_add">
                                                <div className="form-content">
                                                    <div className="row">

                                                        <div className="col-md-12">



                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </Tab.Pane>

                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "0px solid #ffffff" }}>
                        <div>
                            <Row>

                                {/* <Col
                                    style={{
                                        // display: this.state.tabkey == 2 ? "flex" : "none",
                                        padding: 2,
                                    }}
                                >
                                    <a
                                        href="#"
                                        id="simpanData"
                                        className="btn btn-success waves-effect"
                                        onClick={this.update_v3.bind(this)}
                                    >
                                        {" "}
                                        {this.state.updateBtnV3 ? "update" : "Save"}
                                    </a>
                                </Col> */}
                                <Col style={{ padding: 2 }}>
                                    <a
                                        href="#"
                                        id="btnCancelForm"
                                        className="btn btn-danger"
                                        onClick={this.handleCloseModalPemeriksaan.bind(this)}
                                    >
                                        {" "}
                                        Cancel
                                    </a>
                                </Col>
                            </Row>
                        </div>

                    </Modal.Footer>
                </Modal>

                <Row>
                    <Col md={12} style={{ cursor: 'pointer' }}>
                        {tableInbox ? (
                            <PaginationProvider pagination={paginationFactory(options)}>
                                {contentTableInbox}
                            </PaginationProvider>
                        ) : null}
                    </Col>

                </Row>

            </>
        );
    }
}
export default withRouter(People)
